webpackJsonp([0,1],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Eventful = __webpack_require__(6);
var StorageManager = __webpack_require__(7);

module.exports = {
  eventful: new Eventful(),
  storage: new StorageManager('lost-without-you')
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);
var Utils = __webpack_require__(28);

var BaseState = function () {
  function BaseState(game, name) {
    _classCallCheck(this, BaseState);

    this.env = env;
    this.utils = new Utils();
    this.game = game;
    this.name = name;
    this.setupDOM();
    this.observe();
  }

  _createClass(BaseState, [{
    key: 'setupDOM',
    value: function setupDOM() {
      this.dom = {};
      this.dom.state = document.querySelector('.state-' + this.name);
    }
  }, {
    key: 'observe',
    value: function observe() {
      var _this = this;

      this.env.eventful.on('game-animate', function (e) {
        return _this.update(e);
      });
    }
  }, {
    key: 'activate',
    value: function activate() {
      this.isActive = true;
      this.game.currentState = this;
      this.dom.state.classList.add('state-active');
      this.env.eventful.trigger(this.name + '-state-activate');
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      this.isActive = false;
      this.dom.state.classList.remove('state-active');
      this.env.eventful.trigger(this.name + '-state-deactivate');
    }
  }, {
    key: 'update',
    value: function update() {
      if (!this.isActive) {
        return;
      }
    }
  }]);

  return BaseState;
}();

module.exports = BaseState;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Calc = function () {
  function Calc() {
    _classCallCheck(this, Calc);
  }

  _createClass(Calc, [{
    key: "rand",


    /*
    ------------------------------------------
    | rand:float - returns random float
    |
    | min:number - minimum value
    | max:number - maximum value
    | ease:function - easing function to apply to the random value
    |
    | Get a random float between two values,
    | with the option of easing bias.
    ------------------------------------------ */
    value: function rand(min, max, ease) {
      if (max === undefined) {
        max = min;
        min = 0;
      }
      var random = Math.random();
      if (ease) {
        random = ease(random, 0, 1, 1);
      }
      return random * (max - min) + min;
    }

    /*
    ------------------------------------------
    | randInt:integer - returns random integer
    |
    | min:number - minimum value
    | max:number - maximum value
    | ease:function - easing function to apply to the random value
    |
    | Get a random integer between two values,
    | with the option of easing bias.
    ------------------------------------------ */

  }, {
    key: "randInt",
    value: function randInt(min, max, ease) {
      if (max === undefined) {
        max = min;
        min = 0;
      }
      var random = Math.random();
      if (ease) {
        random = ease(random, 0, 1, 1);
      }
      return Math.floor(random * (max - min + 1)) + min;
    }

    /*
    ------------------------------------------
    | randArr:item - returns random iem from array
    |
    | arr:array - the array to randomly pull from
    |
    | Get a random item from an array.
    ------------------------------------------ */

  }, {
    key: "randArr",
    value: function randArr(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    /*
    ------------------------------------------
    | map:number - returns a mapped value
    |
    | val:number - input value
    | inputMin:number - minimum of input range
    | inputMax:number - maximum of input range
    | outputMin:number - minimum of output range
    | outputMax:number - maximum of output range
    |
    | Get a mapped value from and input min/max
    | to an output min/max.
    ------------------------------------------ */

  }, {
    key: "map",
    value: function map(val, inputMin, inputMax, outputMin, outputMax) {
      return (outputMax - outputMin) * ((val - inputMin) / (inputMax - inputMin)) + outputMin;
    }

    /*
    ------------------------------------------
    | clamp:number - returns clamped value
    |
    | val:number - value to be clamped
    | min:number - minimum of clamped range
    | max:number - maximum of clamped range
    |
    | Clamp a value to a min/max range.
    ------------------------------------------ */

  }, {
    key: "clamp",
    value: function clamp(val, min, max) {
      return Math.max(Math.min(val, max), min);
    }
  }, {
    key: "lerp",
    value: function lerp(current, target, mix) {
      return current + (target - current) * mix;
    }

    /*
    ------------------------------------------
    | roundToUpperInterval:number - returns rounded up value
    |
    | value:number - value to be rounded
    | interval:number - interval
    |
    | Round up a value to the next highest interval.
    ------------------------------------------ */

  }, {
    key: "roundToUpperInterval",
    value: function roundToUpperInterval(value, interval) {
      if (value % interval === 0) {
        value += 0.0001;
      }
      return Math.ceil(value / interval) * interval;
    }

    /*
    ------------------------------------------
    | roundDownToInterval:number - returns rounded down value
    |
    | value:number - value to be rounded
    | interval:number - interval
    |
    | Round down a value to the next lowest interval.
    ------------------------------------------ */

  }, {
    key: "roundToLowerInterval",
    value: function roundToLowerInterval(value, interval) {
      if (value % interval === 0) {
        value -= 0.0001;
      }
      return Math.floor(value / interval) * interval;
    }

    /*
    ------------------------------------------
    | roundToNearestInterval:number - returns rounded value
    |
    | value:number - value to be rounded
    | interval:number - interval
    |
    | Round a value to the nearest interval.
    ------------------------------------------ */

  }, {
    key: "roundToNearestInterval",
    value: function roundToNearestInterval(value, interval) {
      return Math.round(value / interval) * interval;
    }

    /*
    ------------------------------------------
    | intersectSphere:boolean - returns if intersecting or not
    |
    | a:object - sphere 1 with radius, x, y, and z
    | b:object - sphere 2 with radius, x, y, and z
    |
    | Check if two sphere are intersecting
    | in 3D space.
    ------------------------------------------ */

  }, {
    key: "intersectSphere",
    value: function intersectSphere(a, b) {
      var distance = Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y) + (a.z - b.z) * (a.z - b.z));
      return distance < a.radius + b.radius;
    }

    /*
    ------------------------------------------
    | getIndexFromCoords:number - returns index
    |
    | x:number - x value (column)
    | y:number - y value (row)
    | w:number - width of grid
    |
    | Convert from grid coords to index.
    ------------------------------------------ */

  }, {
    key: "getIndexFromCoords",
    value: function getIndexFromCoords(x, y, w) {
      return x + y * w;
    }

    /*
    ------------------------------------------
    | getCoordsFromIndex:object - returns coords
    |
    | i:number - index
    | w:number - width of grid
    |
    | Convert from index to grid coords.
    ------------------------------------------ */

  }, {
    key: "getCoordsFromIndex",
    value: function getCoordsFromIndex(i, w) {
      return {
        x: i % w,
        y: Math.floor(i / w)
      };
    }
  }]);

  return Calc;
}();

module.exports = Calc;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ease = function () {
  function Ease() {
    _classCallCheck(this, Ease);
  }

  /*
  ------------------------------------------
  | inQuad:float - returns eased float value
  |
  | t:number - current time
  | b:number - beginning value
  | c:number - change in value
  | d:number - duration
  |
  | Get an eased float value based on inQuad.
  ------------------------------------------ */


  _createClass(Ease, [{
    key: "inQuad",
    value: function inQuad(t, b, c, d) {
      return c * (t /= d) * t + b;
    }

    /*
    ------------------------------------------
    | outQuad:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on outQuad.
    ------------------------------------------ */

  }, {
    key: "outQuad",
    value: function outQuad(t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    }

    /*
    ------------------------------------------
    | inOutQuad:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inOutQuad.
    ------------------------------------------ */

  }, {
    key: "inOutQuad",
    value: function inOutQuad(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t + b;
      return -c / 2 * (--t * (t - 2) - 1) + b;
    }

    /*
    ------------------------------------------
    | inCubic:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inCubic.
    ------------------------------------------ */

  }, {
    key: "inCubic",
    value: function inCubic(t, b, c, d) {
      return c * (t /= d) * t * t + b;
    }

    /*
    ------------------------------------------
    | outCubic:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on outCubic.
    ------------------------------------------ */

  }, {
    key: "outCubic",
    value: function outCubic(t, b, c, d) {
      return c * ((t = t / d - 1) * t * t + 1) + b;
    }

    /*
    ------------------------------------------
    | inOutCubic:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inOutCubic.
    ------------------------------------------ */

  }, {
    key: "inOutCubic",
    value: function inOutCubic(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
      return c / 2 * ((t -= 2) * t * t + 2) + b;
    }

    /*
    ------------------------------------------
    | inQuart:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inQuart.
    ------------------------------------------ */

  }, {
    key: "inQuart",
    value: function inQuart(t, b, c, d) {
      return c * (t /= d) * t * t * t + b;
    }

    /*
    ------------------------------------------
    | outQuart:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on outQuart.
    ------------------------------------------ */

  }, {
    key: "outQuart",
    value: function outQuart(t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    }

    /*
    ------------------------------------------
    | inOutQuart:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inOutQuart.
    ------------------------------------------ */

  }, {
    key: "inOutQuart",
    value: function inOutQuart(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }

    /*
    ------------------------------------------
    | inQuint:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inQuint.
    ------------------------------------------ */

  }, {
    key: "inQuint",
    value: function inQuint(t, b, c, d) {
      return c * (t /= d) * t * t * t * t + b;
    }

    /*
    ------------------------------------------
    | outQuint:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on outQuint.
    ------------------------------------------ */

  }, {
    key: "outQuint",
    value: function outQuint(t, b, c, d) {
      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    }

    /*
    ------------------------------------------
    | inOutQuint:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inOutQuint.
    ------------------------------------------ */

  }, {
    key: "inOutQuint",
    value: function inOutQuint(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    }

    /*
    ------------------------------------------
    | inSine:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inSine.
    ------------------------------------------ */

  }, {
    key: "inSine",
    value: function inSine(t, b, c, d) {
      return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    }

    /*
    ------------------------------------------
    | outSine:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on outSine.
    ------------------------------------------ */

  }, {
    key: "outSine",
    value: function outSine(t, b, c, d) {
      return c * Math.sin(t / d * (Math.PI / 2)) + b;
    }

    /*
    ------------------------------------------
    | inOutSine:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inOutSine.
    ------------------------------------------ */

  }, {
    key: "inOutSine",
    value: function inOutSine(t, b, c, d) {
      return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    }

    /*
    ------------------------------------------
    | inExpo:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inExpo.
    ------------------------------------------ */

  }, {
    key: "inExpo",
    value: function inExpo(t, b, c, d) {
      return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    }

    /*
    ------------------------------------------
    | outExpo:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on outExpo.
    ------------------------------------------ */

  }, {
    key: "outExpo",
    value: function outExpo(t, b, c, d) {
      return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    }

    /*
    ------------------------------------------
    | inOutExpo:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inOutExpo.
    ------------------------------------------ */

  }, {
    key: "inOutExpo",
    value: function inOutExpo(t, b, c, d) {
      if (t == 0) return b;
      if (t == d) return b + c;
      if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }

    /*
    ------------------------------------------
    | inCirc:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inCirc.
    ------------------------------------------ */

  }, {
    key: "inCirc",
    value: function inCirc(t, b, c, d) {
      return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    }

    /*
    ------------------------------------------
    | outCirc:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on outCirc.
    ------------------------------------------ */

  }, {
    key: "outCirc",
    value: function outCirc(t, b, c, d) {
      return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    }

    /*
    ------------------------------------------
    | inOutCirc:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inOutCirc.
    ------------------------------------------ */

  }, {
    key: "inOutCirc",
    value: function inOutCirc(t, b, c, d) {
      if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    }

    /*
    ------------------------------------------
    | inElastic:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inElastic.
    ------------------------------------------ */

  }, {
    key: "inElastic",
    value: function inElastic(t, b, c, d) {
      var s = 1.70158;var p = 0;var a = c;
      if (t == 0) return b;if ((t /= d) == 1) return b + c;if (!p) p = d * .3;
      if (a < Math.abs(c)) {
        a = c;var _s = p / 4;
      } else s = p / (2 * Math.PI) * Math.asin(c / a);
      return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    }

    /*
    ------------------------------------------
    | outElastic:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on outElastic.
    ------------------------------------------ */

  }, {
    key: "outElastic",
    value: function outElastic(t, b, c, d) {
      var s = 1.70158;var p = 0;var a = c;
      if (t == 0) return b;if ((t /= d) == 1) return b + c;if (!p) p = d * .3;
      if (a < Math.abs(c)) {
        a = c;var _s2 = p / 4;
      } else s = p / (2 * Math.PI) * Math.asin(c / a);
      return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    }

    /*
    ------------------------------------------
    | inOutElastic:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    |
    | Get an eased float value based on inOutElastic.
    ------------------------------------------ */

  }, {
    key: "inOutElastic",
    value: function inOutElastic(t, b, c, d) {
      var s = 1.70158;var p = 0;var a = c;
      if (t == 0) return b;if ((t /= d / 2) == 2) return b + c;if (!p) p = d * (.3 * 1.5);
      if (a < Math.abs(c)) {
        a = c;var _s3 = p / 4;
      } else s = p / (2 * Math.PI) * Math.asin(c / a);
      if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
    }

    /*
    ------------------------------------------
    | inBack:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    | s:number - strength
    |
    | Get an eased float value based on inBack.
    ------------------------------------------ */

  }, {
    key: "inBack",
    value: function inBack(t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      return c * (t /= d) * t * ((s + 1) * t - s) + b;
    }

    /*
    ------------------------------------------
    | outBack:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    | s:number - strength
    |
    | Get an eased float value based on outBack.
    ------------------------------------------ */

  }, {
    key: "outBack",
    value: function outBack(t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    }

    /*
    ------------------------------------------
    | inOutBack:float - returns eased float value
    |
    | t:number - current time
    | b:number - beginning value
    | c:number - change in value
    | d:number - duration
    | s:number - strength
    |
    | Get an eased float value based on inOutBack.
    ------------------------------------------ */

  }, {
    key: "inOutBack",
    value: function inOutBack(t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    }
  }]);

  return Ease;
}();

module.exports = Ease;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, THREE) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);
var Firefly = __webpack_require__(15);
var Hero = __webpack_require__(16);

var BaseLevel = function () {
  function BaseLevel(game, name) {
    _classCallCheck(this, BaseLevel);

    this.env = env;
    this.game = game;
    this.name = name;
    this.observe();
  }

  _createClass(BaseLevel, [{
    key: 'observe',
    value: function observe() {
      var _this = this;

      this.env.eventful.on('game-animate', function (e) {
        return _this.update(e);
      });
    }
  }, {
    key: 'build',
    value: function build() {
      this.parseMaze();
      this.setupLights();
      this.setupGround();
      this.setupWalls();
      this.setupHeros();
      this.setupFireflies();
    }
  }, {
    key: 'parseMaze',
    value: function parseMaze() {
      var _this2 = this;

      this.mazeTrimmed = _.trim(this.maze);
      this.mazeLines = this.mazeTrimmed.split('\n');
      this.mazeArray = [];
      this.mazeLines.forEach(function (line) {
        _this2.mazeArray.push(_.trim(line).split(' '));
      });
      this.mazeArray.forEach(function (line) {
        line.forEach(function (item, i, arr) {
          arr[i] = parseInt(item, 10);
        });
      });
      this.mazeRows = this.mazeArray[0].length;
      this.mazeCols = this.mazeArray.length;
    }
  }, {
    key: 'setupLights',
    value: function setupLights() {
      this.ambientLight = new THREE.AmbientLight(0x111111);
      this.game.world.scene.add(this.ambientLight);
    }
  }, {
    key: 'setupGround',
    value: function setupGround() {
      this.groundGeometry = new THREE.PlaneBufferGeometry(this.mazeRows, this.mazeCols);
      this.groundGeometry.applyMatrix(new THREE.Matrix4().makeRotationX(-Math.PI / 2));
      this.groundMaterial = new THREE.MeshPhongMaterial({
        color: 0x666666,
        specular: 0x333333,
        shininess: 30
      });
      this.groundMesh = new THREE.Mesh(this.groundGeometry, this.groundMaterial);
      this.groundMesh.castShadow = false;
      this.groundMesh.receiveShadow = true;
      this.groundMesh.position.set(0, 0, 0);
      this.game.world.scene.add(this.groundMesh);
    }
  }, {
    key: 'setupWalls',
    value: function setupWalls() {
      var _this3 = this;

      this.walls = [];
      this.walls2 = [];
      this.mazeArray.forEach(function (line, i) {
        var currWall = {};
        var hasWall = false;
        //let wallWidth = 1;
        line.forEach(function (item, j) {
          if (item === 3) {
            if (hasWall) {
              //wallWidth++
              currWall.width++;
              currWall.x += 0.5;
            } else {
              currWall = {
                x: j - _this3.mazeCols / 2,
                z: i - _this3.mazeRows / 2,
                width: 1
              };
              hasWall = true;
              _this3.walls2.push(currWall);
            }
            // let x = j - this.mazeCols / 2;
            // let z = i - this.mazeRows / 2;
            // let mesh = new THREE.Mesh(this.game.wallGeometry, this.game.wallMaterial);
            // mesh.castShadow = true;
            // mesh.receiveShadow = true;
            // mesh.position.set(x + 0.5, 0.5, z + 0.5);
            // mesh.bbox = new THREE.Box3();
            // mesh.bbox.setFromObject(mesh);
            // this.walls.push(mesh);
            // this.game.world.scene.add(mesh);
          } else {
            hasWall = false;
          }
        });
      });

      this.walls2.forEach(function (wall) {
        var mesh = new THREE.Mesh(new THREE.BoxBufferGeometry(wall.width, 1, 1), _this3.game.wallMaterial);
        mesh.castShadow = true;
        mesh.receiveShadow = true;
        mesh.position.set(wall.x + 0.5, 0.5, wall.z + 0.5);
        mesh.bbox = new THREE.Box3();
        mesh.bbox.setFromObject(mesh);
        _this3.walls.push(mesh);
        _this3.game.world.scene.add(mesh);
      });
    }
  }, {
    key: 'setupHeros',
    value: function setupHeros() {
      var _this4 = this;

      this.mazeArray.forEach(function (line, i) {
        line.forEach(function (item, j) {
          if (item === 1 || item === 2) {
            var x = j - _this4.mazeCols / 2;
            var y = 0;
            var z = i - _this4.mazeRows / 2;
            var origin = new THREE.Vector3(x + 0.5, y, z + 0.5);
            if (item === 1) {
              _this4.game.heroA = new Hero(_this4.game, 'a', origin);
            }
            if (item === 2) {
              _this4.game.heroB = new Hero(_this4.game, 'b', origin);
            }
          }
        });
      });
    }
  }, {
    key: 'setupFireflies',
    value: function setupFireflies() {
      var _this5 = this;

      this.mazeArray.forEach(function (line, i) {
        line.forEach(function (item, j) {
          var off = i % 6 === 0 ? 1 : 0;
          if (item === 0 && i % 3 === 0 && (j + off) % 3 === 0) {
            var x = j - _this5.mazeCols / 2 + 0.5;
            var y = 0.29;
            var z = i - _this5.mazeRows / 2 + 0.5;
            _this5.game.fireflies.push(new Firefly(_this5.game, new THREE.Vector3(x, y, z)));
          }
        });
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var i = this.game.fireflies.length;
      while (i--) {
        var firefly = this.game.fireflies[i];
        firefly.destroy();
      }
      this.game.fireflies.length = 0;

      this.game.heroA.destroy();
      this.game.heroB.destroy();
      this.game.heroA = null;
      this.game.heroB = null;
      this.game.activeHero = null;

      this.game.world.scene.remove(this.ambientLight);
      this.ambientLight = null;

      this.game.world.scene.remove(this.groundMesh);
      this.groundGeometry.dispose();
      this.groundMaterial.dispose();
      this.groundMesh = null;

      this.mazeTrimmed = null;
      this.mazeLines = null;
      this.mazeArray = null;
      this.mazeRows = null;
      this.mazeCols = null;

      var j = this.walls.length;
      while (j--) {
        var wall = this.walls[j];
        this.game.world.scene.remove(wall);
        wall.geometry.dispose();
        wall = null;
      }
      this.walls.length = 0;
    }
  }, {
    key: 'update',
    value: function update() {}
  }]);

  return BaseLevel;
}();

module.exports = BaseLevel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13), __webpack_require__(0)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Eventful = function () {

  /*
  ------------------------------------------
  | constructor:void
  |
  | Construct.
  ------------------------------------------ */
  function Eventful() {
    _classCallCheck(this, Eventful);

    this._events = [];
  }

  /*
  ------------------------------------------
  | validateEventType:null
  |
  | type:string - event name
  |
  | Validate event type.
  ------------------------------------------ */


  _createClass(Eventful, [{
    key: 'validateEventType',
    value: function validateEventType(type) {
      if (/^[a-z\-_]+$/g.test(type) === false) {
        throw 'Error: type type must be a string (a-z, -, _)!';
      }
    }

    /*
    ------------------------------------------
    | validateEventCallback:null
    |
    | cb:function - callback
    |
    | Validate event callback.
    ------------------------------------------ */

  }, {
    key: 'validateEventCallback',
    value: function validateEventCallback(cb) {
      if (typeof cb !== 'function') {
        throw 'Error: callback must be a function!';
      }
    }

    /*
    ------------------------------------------
    | eventTypeExists:boolean
    |
    | type:string - event name
    |
    | Does this event type exist.
    ------------------------------------------ */

  }, {
    key: 'eventTypeExists',
    value: function eventTypeExists(type) {
      return this._events.hasOwnProperty(type);
    }

    /*
    ------------------------------------------
    | on:object
    |
    | type:string - event name
    | cb:function - callback
    |
    | Register an event.
    ------------------------------------------ */

  }, {
    key: 'on',
    value: function on(type, cb) {
      // check type / cb
      this.validateEventType(type);
      this.validateEventCallback(cb);

      // add type if it doesn't exist
      if (this.eventTypeExists(type) === false) {
        this._events[type] = [];
      }

      // register event
      this._events[type].unshift(cb);

      // return this for chainging
      return this;
    }

    /*
    ------------------------------------------
    | off:object
    |
    | type:string - event name
    | ...args[0]:function - callback
    |
    | Remove an event.
    ------------------------------------------ */

  }, {
    key: 'off',
    value: function off(type) {
      var _this = this;

      var index = void 0;

      // check type
      this.validateEventType(type);

      // are there any events with this type?
      if (this.eventTypeExists(type) === false) {
        return this;
      }

      // if no cb was specfied, remove them all
      if ((arguments.length <= 1 ? 0 : arguments.length - 1) === 0) {
        this._events[type] = [];
        return this;
      }

      // check args
      this.validateEventCallback(arguments.length <= 1 ? undefined : arguments[1]);

      // are there any listeners?
      index = this._events[type].indexOf(arguments.length <= 1 ? undefined : arguments[1]);
      if (index !== -1) {
        setTimeout(function () {
          _this._events[type].splice(index, 1);
        }, 0);
      }

      // return this for chainging
      return this;
    }

    /*
    ------------------------------------------
    | trigger:object
    |
    | type:string - event name
    | data:array - data to callback
    |
    | Trigger an event.
    ------------------------------------------ */

  }, {
    key: 'trigger',
    value: function trigger(type) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // check type / data
      this.validateEventType(type);

      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
        throw 'Error: data must be an object!';
      }

      // are there any listeners?
      if (this.eventTypeExists(type) === false) {
        return this;
      }

      // pass type to callbacks
      data.ev_type = type;

      // execute callbacks
      this._events[type].forEach(function (cb) {
        cb.call(_this2, data);
      });

      // return this for chainging
      return this;
    }
  }]);

  return Eventful;
}();

module.exports = Eventful;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);

var StorageManager = function () {
  function StorageManager(namespace) {
    _classCallCheck(this, StorageManager);

    this.env = env;

    Storage.prototype.setObject = function (key, value) {
      this.setItem(key, JSON.stringify(value));
    };

    Storage.prototype.getObject = function (key) {
      var value = this.getItem(key);
      return value && JSON.parse(value);
    };

    Storage.prototype.removeObject = function (key) {
      this.removeItem(key);
    };

    this.namespace = namespace;
    this.obj = localStorage.getObject(this.namespace) || {};
  }

  _createClass(StorageManager, [{
    key: 'get',
    value: function get(key) {
      return this.obj[key];
    }
  }, {
    key: 'set',
    value: function set(key, val) {
      this.obj[key] = val;
      this.sync();
    }
  }, {
    key: 'sync',
    value: function sync() {
      localStorage.setObject(this.namespace, this.obj);
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.obj = {};
      this.sync();
    }
  }]);

  return StorageManager;
}();

module.exports = StorageManager;

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);
var Calc = __webpack_require__(3);
var Ease = __webpack_require__(4);
var Keys = __webpack_require__(10);
var LevelManager = __webpack_require__(11);
var StateManager = __webpack_require__(26);
var Time = __webpack_require__(33);
var World = __webpack_require__(34);

__webpack_require__(48);

var Game = function () {
  function Game() {
    _classCallCheck(this, Game);

    this.build();
  }

  _createClass(Game, [{
    key: 'build',
    value: function build() {
      this.env = env;
      this.calc = new Calc();
      this.ease = new Ease();

      this.debug = location.hash.indexOf('debug') > -1;
      this.resolution = {};

      this.setupDOM();
      this.setupStorage();
      this.setupTime();
      this.setupWorld();
      this.setupStates();
      this.setupFireflies();
      this.setupLevels();
      this.setupInputs();
      this.setupSounds();
      this.onResize();
      this.start();
      this.observe();
    }
  }, {
    key: 'setupDOM',
    value: function setupDOM() {
      this.dom = {};
      this.dom.container = document.querySelector('.container');
      this.dom.scaler = document.querySelector('.scaler');
    }
  }, {
    key: 'setupStorage',
    value: function setupStorage() {
      if (!this.env.storage.get('level1')) {
        this.env.storage.set('level1', {
          name: 'level1',
          index: 0,
          available: true,
          beaten: false,
          bestTime: null,
          timesPlayed: 0
        });
      }

      if (!this.env.storage.get('level2')) {
        this.env.storage.set('level2', {
          name: 'level2',
          index: 1,
          available: false,
          beaten: false,
          bestTime: null,
          timesPlayed: 0
        });
      }

      if (!this.env.storage.get('level3')) {
        this.env.storage.set('level3', {
          name: 'level3',
          index: 2,
          available: false,
          beaten: false,
          bestTime: null,
          timesPlayed: 0
        });
      }

      if (!this.env.storage.get('level4')) {
        this.env.storage.set('level4', {
          name: 'level4',
          index: 3,
          available: false,
          beaten: false,
          bestTime: null,
          timesPlayed: 0
        });
      }
    }
  }, {
    key: 'setupTime',
    value: function setupTime() {
      this.time = new Time();
    }
  }, {
    key: 'setupWorld',
    value: function setupWorld() {
      this.world = new World({ game: this });
    }
  }, {
    key: 'setupStates',
    value: function setupStates() {
      this.stateManager = new StateManager(this);
      //this.stateManager.set('play');
      this.stateManager.set('menu');
    }
  }, {
    key: 'setupFireflies',
    value: function setupFireflies() {
      this.fireflyGeometry = new THREE.SphereBufferGeometry(0.01, 0.01, 72, 72);
      this.fireflyMaterial = new THREE.MeshBasicMaterial({
        color: 0xffffff
      });

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var size = 512;
      canvas.width = size;
      canvas.height = size;
      var glow_gradient = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
      var steps = 20;
      for (var i = 0; i < steps; i++) {
        var p = i / (steps - 1);
        var a = this.calc.map(this.ease.outExpo(p, 0, 1, 1), 0, 1, 1, 0);
        glow_gradient.addColorStop(p, 'hsla(60, 100%, 40%, ' + a + ')');
      }
      ctx.fillStyle = glow_gradient;
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      ctx.fill();
      var texture = new THREE.Texture(canvas);
      texture.needsUpdate = true;
      this.fireflyGlowMaterial = new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
        blending: THREE.AdditiveBlending
      });
      this.fireflies = [];
    }
  }, {
    key: 'setupLevels',
    value: function setupLevels() {
      this.wallGeometry = new THREE.BoxBufferGeometry(1, 1, 1);
      this.wallMaterial = new THREE.MeshPhongMaterial({
        color: 0x666666,
        specular: 0x666666,
        shininess: 20
      });

      this.levelManager = new LevelManager(this);
    }
  }, {
    key: 'setupInputs',
    value: function setupInputs() {
      this.keys = new Keys();
      this.dir = {
        up: false,
        down: false,
        left: false,
        right: false
      };
    }
  }, {
    key: 'setupSounds',
    value: function setupSounds() {
      this.sounds = {
        fireflyCollect: new Howl({
          src: ['./sounds/firefly-collect.mp3'],
          volume: 1,
          rate: 1.5
        }),
        button: new Howl({
          src: ['./sounds/click.mp3'],
          volume: 0.9,
          rate: 2
        }),
        levelIntro: new Howl({
          src: ['./sounds/intro.mp3'],
          volume: 1
        }),
        death: new Howl({
          src: ['./sounds/death.mp3'],
          volume: 0.15
        }),
        unite: new Howl({
          src: ['./sounds/unite.mp3'],
          volume: 0.1
        }),
        zoey: new Howl({
          src: ['./sounds/zoey.mp3'],
          volume: 1
        }),
        mary: new Howl({
          src: ['./sounds/mary.mp3'],
          volume: 0.2
        }),
        switch: new Howl({
          src: ['./sounds/switch.mp3'],
          volume: 0.4
        }),
        music: new Howl({
          src: ['./sounds/music.mp3'],
          volume: 0.3,
          pool: 1,
          loop: true
        })
      };
    }
  }, {
    key: 'playSound',
    value: function playSound(sound) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.muted) {
        if (config && config.volume) {
          sound.volume(config.volume);
        }
        if (config && config.rate) {
          sound.rate(config.rate);
        }
        sound.play();
      }
    }
  }, {
    key: 'observe',
    value: function observe() {
      var _this = this;

      window.addEventListener('resize', function () {
        return _this.onResize();
      });

      this.env.eventful.on('dir-pressed', function (e) {
        return _this.onDirPressed(e);
      });
      this.env.eventful.on('dir-released', function (e) {
        return _this.onDirReleased(e);
      });
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      var ratioWin = window.innerWidth / window.innerHeight;
      var ratioGame = 16 / 9;

      if (ratioWin > ratioGame) {
        this.resolution.x = window.innerHeight * ratioGame;
        this.resolution.y = window.innerHeight;
      } else {
        this.resolution.x = window.innerWidth;
        this.resolution.y = window.innerWidth / ratioGame;
      }

      this.aspect = this.resolution.x / this.resolution.y;
      //this.dpr = window.devicePixelRatio > 1 ? 2 : 1;
      this.dpr = 1;
      if (window.devicePixelRatio > 1) {
        document.body.classList.add('retina');
      } else {
        document.body.classList.remove('retina');
      }

      this.dom.container.style.width = this.resolution.x + 'px';
      this.dom.container.style.height = this.resolution.y + 'px';

      this.dom.scaler.style.transform = 'scale(' + this.resolution.y / 1080 + ')';

      this.domOffset = {
        x: Math.round(this.dom.container.offsetLeft),
        y: Math.round(this.dom.container.offsetTop)
      };

      this.env.eventful.trigger('game-resize', {
        resolution: this.resolution,
        aspect: this.aspect,
        dpr: this.dpr,
        domOffset: this.domOffset
      });
    }
  }, {
    key: 'onDirPressed',
    value: function onDirPressed(e) {
      this.dir[e.dir] = true;
    }
  }, {
    key: 'onDirReleased',
    value: function onDirReleased(e) {
      this.dir[e.dir] = false;
    }
  }, {
    key: 'start',
    value: function start() {
      this.raf = this.animate();
    }
  }, {
    key: 'stop',
    value: function stop() {
      window.cancelAnimationFrame(this.raf);
    }
  }, {
    key: 'update',
    value: function update() {}
  }, {
    key: 'animate',
    value: function animate() {
      var _this2 = this;

      this.update();
      this.env.eventful.trigger('game-animate');
      this.raf = window.requestAnimationFrame(function () {
        return _this2.animate();
      });
    }
  }]);

  return Game;
}();

module.exports = new Game();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);

var Keys = function () {
  function Keys(game) {
    _classCallCheck(this, Keys);

    this.env = env;
    this.game = game;

    this.keyWatch = {
      up: [87, 38], // w, up
      down: [83, 40], // s, down
      left: [65, 37], // a, left
      right: [68, 39] // d, right
    };

    this.observe();
  }

  _createClass(Keys, [{
    key: 'observe',
    value: function observe() {
      var _this = this;

      window.addEventListener('keydown', function (e) {
        return _this.onKeydown(e);
      });
      window.addEventListener('keyup', function (e) {
        return _this.onKeyup(e);
      });
    }
  }, {
    key: 'onKeydown',
    value: function onKeydown(e) {
      var key = e.which;
      if (this.keyWatch.up.indexOf(key) > -1) {
        this.env.eventful.trigger('dir-pressed', { dir: 'up' });
      }
      if (this.keyWatch.down.indexOf(key) > -1) {
        this.env.eventful.trigger('dir-pressed', { dir: 'down' });
      }
      if (this.keyWatch.left.indexOf(key) > -1) {
        this.env.eventful.trigger('dir-pressed', { dir: 'left' });
      }
      if (this.keyWatch.right.indexOf(key) > -1) {
        this.env.eventful.trigger('dir-pressed', { dir: 'right' });
      }
    }
  }, {
    key: 'onKeyup',
    value: function onKeyup(e) {
      var key = e.which;
      if (this.keyWatch.up.indexOf(key) > -1) {
        this.env.eventful.trigger('dir-released', { dir: 'up' });
      }
      if (this.keyWatch.down.indexOf(key) > -1) {
        this.env.eventful.trigger('dir-released', { dir: 'down' });
      }
      if (this.keyWatch.left.indexOf(key) > -1) {
        this.env.eventful.trigger('dir-released', { dir: 'left' });
      }
      if (this.keyWatch.right.indexOf(key) > -1) {
        this.env.eventful.trigger('dir-released', { dir: 'right' });
      }
    }
  }]);

  return Keys;
}();

module.exports = Keys;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);
var Level1 = __webpack_require__(12);
var Level2 = __webpack_require__(20);
var Level3 = __webpack_require__(22);
var Level4 = __webpack_require__(24);

var LevelManager = function () {
  function LevelManager(game) {
    _classCallCheck(this, LevelManager);

    this.env = env;
    this.game = game;

    this.levelNames = ['level1', 'level2', 'level3', 'level4'];

    this.levels = {
      level1: new Level1(this.game, 'level1'),
      level2: new Level2(this.game, 'level2'),
      level3: new Level3(this.game, 'level3'),
      level4: new Level4(this.game, 'level4')
    };
  }

  _createClass(LevelManager, [{
    key: 'set',
    value: function set(level) {
      if (this.current) {
        this.current.destroy();
      }
      this.build(level);
    }
  }, {
    key: 'build',
    value: function build(level) {
      this.current = this.levels[level];
      this.current.build();
    }
  }]);

  return LevelManager;
}();

module.exports = LevelManager;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseLevel = __webpack_require__(5);
var Level1Data = __webpack_require__(19);

var Level1 = function (_BaseLevel) {
  _inherits(Level1, _BaseLevel);

  function Level1(game, name) {
    _classCallCheck(this, Level1);

    var _this = _possibleConstructorReturn(this, (Level1.__proto__ || Object.getPrototypeOf(Level1)).call(this, game, name));

    _this.maze = Level1Data;
    return _this;
  }

  _createClass(Level1, [{
    key: 'update',
    value: function update() {
      _get(Level1.prototype.__proto__ || Object.getPrototypeOf(Level1.prototype), 'update', this).call(this);
    }
  }]);

  return Level1;
}(BaseLevel);

module.exports = Level1;

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);
var Calc = __webpack_require__(3);
var Ease = __webpack_require__(4);

var Firefly = function () {
  function Firefly(game, origin) {
    _classCallCheck(this, Firefly);

    this.env = env;
    this.origin = origin;
    this.calc = new Calc();
    this.ease = new Ease();
    this.game = game;

    this.hue = 60;
    this.pulseRate = this.calc.rand(0.001, 0.005);
    this.pulseOffset = this.calc.rand(100);

    this.velocityBase = 0.005;
    this.range = 0.4;
    this.angle = this.calc.rand(Math.PI * 2);

    this.dead = false;

    this.observe();
    this.setupMesh();
    this.setupGlow();
  }

  _createClass(Firefly, [{
    key: 'observe',
    value: function observe() {
      var _this = this;

      this.env.eventful.on('game-animate', function (e) {
        return _this.update(e);
      });
    }
  }, {
    key: 'setupMesh',
    value: function setupMesh() {
      this.mesh = new THREE.Mesh(this.game.fireflyGeometry, this.game.fireflyMaterial);
      this.mesh.position.copy(this.origin);
      this.mesh.bbox = new THREE.Box3();
      this.game.world.scene.add(this.mesh);
    }
  }, {
    key: 'setupGlow',
    value: function setupGlow() {
      this.glowMesh = new THREE.Sprite(this.game.fireflyGlowMaterial);
      this.glowScale = 0.15;
      this.glowMesh.scale.set(this.glowScale, this.glowScale, this.glowScale);
      this.glowMesh.position.set(0, 0, 0);
      this.mesh.add(this.glowMesh);
    }
  }, {
    key: 'move',
    value: function move() {
      var distHeroThreshold = 1;
      var distToHeroA = this.mesh.position.distanceTo(this.game.heroA.mesh.position);
      var distToHeroB = this.mesh.position.distanceTo(this.game.heroB.mesh.position);
      var refHero = this.game.heroA;
      var refDist = distToHeroA;
      if (distToHeroA > distToHeroB) {
        refHero = this.game.heroB;
        refDist = distToHeroB;
      }

      if (refDist < distHeroThreshold && this.game.isPlaying) {
        var dz = this.mesh.position.z - refHero.mesh.position.z;
        var dx = this.mesh.position.x - refHero.mesh.position.x;
        this.angle = Math.atan2(dz, dx) + Math.PI;
        this.velocity = 0.05 * (distHeroThreshold - refDist);
      } else {
        this.velocity = this.calc.map(Math.sin(Date.now() * 0.0025 + this.pulseOffset), -1, 1, this.velocityBase * 0.25, this.velocityBase);
        this.angle += this.calc.rand(-0.5, 0.5);
        if (this.mesh.position.distanceTo(this.origin) > this.range) {
          var _dz = this.mesh.position.z - this.origin.z;
          var _dx = this.mesh.position.x - this.origin.x;
          this.angle = Math.atan2(_dz, _dx) + Math.PI;
        }
      }

      this.mesh.position.x += Math.cos(this.angle) * this.velocity * this.game.time.dtn;
      this.mesh.position.z += Math.sin(this.angle) * this.velocity * this.game.time.dtn;

      this.mesh.bbox.setFromObject(this.mesh);
    }
  }, {
    key: 'pulse',
    value: function pulse() {
      var scale = this.calc.map(Math.sin(Date.now() * this.pulseRate + this.pulseOffset), -1, 1, 0.1, 0.4);
      this.glowMesh.scale.set(scale, scale, scale);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.dead = true;
      this.game.world.scene.remove(this.mesh);
      this.mesh = null;
      this.glowMesh = null;
    }
  }, {
    key: 'update',
    value: function update() {
      if (this.game.stateManager.current != 'play') {
        return;
      }
      if (!this.dead) {
        this.move();
        this.pulse();
      }
    }
  }]);

  return Firefly;
}();

module.exports = Firefly;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);
var Calc = __webpack_require__(3);
var Ease = __webpack_require__(4);
var ParticleSystem = __webpack_require__(17);

var Hero = function () {
  function Hero(game, name, origin) {
    _classCallCheck(this, Hero);

    this.env = env;
    this.calc = new Calc();
    this.ease = new Ease();
    this.game = game;
    this.name = name;
    this.origin = origin;

    this.isActive = false;

    this.hue = this.name === 'a' ? 130 : 210;

    this.life = 1;
    this.decay = 0.00175;
    //this.decay = 0;

    this.acceleration = new THREE.Vector3();
    this.velocity = new THREE.Vector3();
    this.accelerationGain = 0.01;
    this.velocityMax = 0.3;
    this.velocityFriction = 0.85;

    this.lightPositionCurrent = new THREE.Vector3();
    this.lightPositionTarget = new THREE.Vector3();
    this.lightDistanceBase = 5;
    this.lightDistanceCurrent = 5;
    this.lightDistanceTarget = 5;
    this.light1Intensity = 0.75;
    this.light2Intensity = 0.25;

    this.observe();
    this.setupMesh();
    this.setupLights();
    this.setupCollisions();
    this.spawnGhost();
    this.setupParticleSystem();
  }

  _createClass(Hero, [{
    key: 'observe',
    value: function observe() {
      var _this = this;

      this.env.eventful.on('game-animate', function (e) {
        return _this.update(e);
      });
    }
  }, {
    key: 'setupMesh',
    value: function setupMesh() {
      this.width = 0.3;
      this.height = 0.3;
      this.depth = 0.3;
      this.geometry = new THREE.BoxBufferGeometry(this.width, this.height, this.depth);
      this.material = new THREE.MeshPhongMaterial({
        color: new THREE.Color('hsl(' + this.hue + ', 80%, 50%)'),
        specular: new THREE.Color('hsl(' + this.hue + ', 80%, 75%)'),
        shininess: 100
      });
      this.mesh = new THREE.Mesh(this.geometry, this.material);
      this.mesh.position.copy(this.origin);
      this.mesh.position.y += this.height / 2;
      this.mesh.castShadow = true;
      this.mesh.receiveShadow = true;
      this.mesh.bbox = new THREE.Box3();
      this.game.world.scene.add(this.mesh);

      this.lifeGeometryBack = new THREE.PlaneBufferGeometry(0.3, 0.015);
      this.lifeGeometryBack.applyMatrix(new THREE.Matrix4().makeRotationX(-Math.PI / 2));
      this.lifeMaterialBack = new THREE.MeshBasicMaterial({
        color: new THREE.Color('hsl(0, 0%, 0%)'),
        transparent: true,
        opacity: 0.25,
        depthTest: false
      });
      this.lifeMeshBack = new THREE.Mesh(this.lifeGeometryBack, this.lifeMaterialBack);
      this.game.world.scene.add(this.lifeMeshBack);

      this.lifeGeometry = new THREE.PlaneBufferGeometry(0.3, 0.015);
      this.lifeGeometry.applyMatrix(new THREE.Matrix4().makeRotationX(-Math.PI / 2));
      this.lifeMaterial = new THREE.MeshBasicMaterial({
        blending: THREE.AdditiveBlending,
        color: new THREE.Color('hsl(' + this.hue + ', 80%, 50%)'),
        transparent: true,
        opacity: 0.45,
        depthTest: false
      });
      this.lifeMeshScaleCurrent = 1;
      this.lifeMeshScaleTarget = 1;
      this.lifeMesh = new THREE.Mesh(this.lifeGeometry, this.lifeMaterial);
      this.game.world.scene.add(this.lifeMesh);
    }
  }, {
    key: 'setupLights',
    value: function setupLights() {
      this.light1 = new THREE.PointLight(new THREE.Color('hsl(' + this.hue + ', 75%, 50%)'), this.light1Intensity, this.lightDistanceBase, 2);
      this.light1.castShadow = false;
      this.mesh.add(this.light1);

      this.light2 = new THREE.PointLight(new THREE.Color('hsl(' + this.hue + ', 75%, 50%)'), this.light2Intensity, this.lightDistanceBase, 2);
      this.light2.castShadow = true;
      this.light2.shadow.mapSize.width = window.devicePixelRatio > 1 ? 128 : 512;
      this.light2.shadow.mapSize.height = window.devicePixelRatio > 1 ? 128 : 512;
      this.mesh.add(this.light2);
    }
  }, {
    key: 'setupCollisions',
    value: function setupCollisions() {
      this.colliding = {
        up: false,
        down: false,
        left: false,
        right: false
      };
    }
  }, {
    key: 'move',
    value: function move() {
      this.colliding.up = false;
      this.colliding.down = false;
      this.colliding.left = false;
      this.colliding.right = false;

      if (this.isActive && this.game.isPlaying && !this.game.isEnding) {
        if (this.game.dir.left && !this.colliding.left) {
          this.acceleration.x = -this.accelerationGain;
        } else if (this.game.dir.right && !this.colliding.right) {
          this.acceleration.x = this.accelerationGain;
        } else {
          this.acceleration.x = 0;
        }
      } else {
        this.acceleration.x = 0;
      }

      if (!this.game.isEnding) {
        this.velocity.x += this.acceleration.x * this.game.time.dtn;
        this.velocity.x *= this.velocityFriction;
        this.velocity.x = this.calc.clamp(this.velocity.x, -this.velocityMax, this.velocityMax);
        this.mesh.position.x += this.velocity.x;
        this.mesh.bbox.setFromObject(this.mesh);
      }

      var walls = this.game.levelManager.current.walls;
      for (var i = 0, len = walls.length; i < len; i++) {
        var wall = walls[i];
        if (this.mesh.bbox.intersectsBox(wall.bbox)) {
          if (this.mesh.bbox.min.x < wall.bbox.max.x && this.mesh.position.x > wall.position.x && this.velocity.x < 0) {
            this.colliding.left = true;
            this.velocity.x = 0;
            this.mesh.position.x -= this.mesh.bbox.min.x - wall.bbox.max.x - 0.00000001;
          }
          if (this.mesh.bbox.max.x > wall.bbox.min.x && this.mesh.position.x < wall.position.x && this.velocity.x > 0) {
            this.colliding.right = true;
            this.velocity.x = 0;
            this.mesh.position.x -= this.mesh.bbox.max.x - wall.bbox.min.x + 0.00000001;
          }
        }
      }

      if (this.isActive && this.game.isPlaying && !this.game.isEnding) {
        if (this.game.dir.up && !this.colliding.up) {
          this.acceleration.z = -this.accelerationGain;
        } else if (this.game.dir.down && !this.colliding.down) {
          this.acceleration.z = this.accelerationGain;
        } else {
          this.acceleration.z = 0;
        }
      } else {
        this.acceleration.x = 0;
      }

      if (!this.game.isEnding) {
        this.velocity.z += this.acceleration.z * this.game.time.dtn;
        this.velocity.z *= this.velocityFriction;
        this.velocity.z = this.calc.clamp(this.velocity.z, -this.velocityMax, this.velocityMax);
        this.mesh.position.z += this.velocity.z;
        this.mesh.bbox.setFromObject(this.mesh);
      }

      for (var _i = 0, _len = walls.length; _i < _len; _i++) {
        var _wall = walls[_i];
        if (this.mesh.bbox.intersectsBox(_wall.bbox)) {
          if (this.mesh.bbox.min.z < _wall.bbox.max.z && this.mesh.position.z > _wall.position.z && this.velocity.z < 0) {
            this.colliding.up = true;
            this.velocity.z = 0;
            this.mesh.position.z -= this.mesh.bbox.min.z - _wall.bbox.max.z - 0.00000001;
          }
          if (this.mesh.bbox.max.z > _wall.bbox.min.z && this.mesh.position.z < _wall.position.z && this.velocity.z > 0) {
            this.colliding.down = true;
            this.velocity.z = 0;
            this.mesh.position.z -= this.mesh.bbox.max.z - _wall.bbox.min.z + 0.00000001;
          }
        }
      }
    }
  }, {
    key: 'updateLights',
    value: function updateLights() {
      this.lightAngle = Math.atan2(this.velocity.z, this.velocity.x);
      this.lightDistance = Math.sqrt(this.velocity.z * this.velocity.z + this.velocity.x * this.velocity.x) * 10;
      this.lightPositionTarget.x = Math.cos(this.lightAngle) * this.lightDistance;
      this.lightPositionTarget.y = 1.2;
      this.lightPositionTarget.z = Math.sin(this.lightAngle) * this.lightDistance;

      this.lightPositionCurrent.lerp(this.lightPositionTarget, 0.05);

      this.light1.position.copy(this.lightPositionCurrent);
      this.light2.position.copy(this.lightPositionCurrent);
    }
  }, {
    key: 'setActive',
    value: function setActive(active) {
      this.isActive = active;
      if (!active) {
        this.acceleration.x = 0;
        this.acceleration.z = 0;
      }
    }
  }, {
    key: 'collideHeros',
    value: function collideHeros() {
      if (this.game.heroA && this.game.heroB) {
        var otherHero = this.name === 'a' ? this.game.heroB : this.game.heroA;
        if (this.mesh.bbox.intersectsBox(otherHero.mesh.bbox)) {
          if (!this.game.isEnding) {
            this.game.sounds.unite.play();
            this.game.lastLevelPlayed = this.game.currentLevel;
            this.game.lastLevelTime = this.game.currentState.elapsedTime;
            this.env.eventful.trigger('unite');
          }
        }
      }
    }
  }, {
    key: 'collideFireflies',
    value: function collideFireflies() {
      var fireflies = this.game.fireflies;
      var i = fireflies.length;
      while (i--) {
        var firefly = fireflies[i];
        if (this.mesh.bbox.intersectsBox(firefly.mesh.bbox)) {
          firefly.destroy();
          fireflies.splice(i, 1);
          this.collectFirefly();
        }
      }
    }
  }, {
    key: 'collectFirefly',
    value: function collectFirefly() {
      this.life += 0.2;
      this.life = this.calc.clamp(this.life, 0, 1);
      this.ghostOpacity = 1;
      this.ghostScale = 2;
      if (this.isActive) {
        this.game.sounds.fireflyCollect.rate(this.calc.rand(1.5, 2));
        this.game.sounds.fireflyCollect.play();
        this.env.eventful.trigger('collect-firefly');
      }
    }
  }, {
    key: 'spawnGhost',
    value: function spawnGhost() {
      //this.ghostGeometry = new THREE.BoxBufferGeometry(this.width, this.height, this.depth);
      this.ghostGeometry = new THREE.SphereBufferGeometry(this.width, 32, 32);
      this.ghostMaterial = new THREE.MeshPhongMaterial({
        color: 0xffffff,
        transparent: true,
        opacity: 0,
        blending: THREE.AdditiveBlending
      });
      this.ghostMesh = new THREE.Mesh(this.ghostGeometry, this.ghostMaterial);
      this.ghostMesh.position.copy(this.mesh.position);
      //let scale = 1.5;
      //this.ghostMesh.scale.set(scale, scale, scale);
      this.ghostOpacity = 0;
      this.ghostScale = 2;
      this.game.world.scene.add(this.ghostMesh);
    }
  }, {
    key: 'setupParticleSystem',
    value: function setupParticleSystem() {
      this.particleSystem = new ParticleSystem(this.game, this.game.world.scene, this, this.hue);
    }
  }, {
    key: 'updateLightLife',
    value: function updateLightLife() {
      if (this.isActive && this.game.isPlaying && !this.game.isEnding) {
        if (this.life > 0) {
          this.life -= this.decay;
          this.lightDistanceTarget = 0 + this.lightDistanceBase * this.life;
          this.lightDistanceCurrent += (this.lightDistanceTarget - this.lightDistanceCurrent) * 0.2;
          this.light1.distance = this.lightDistanceCurrent;
          this.light2.distance = this.lightDistanceCurrent;
        } else {
          this.game.sounds.death.play();
          this.light1.distance = 0;
          this.light2.distance = 0;
          this.game.lastLevelPlayed = this.game.currentLevel;
          this.game.lastLevelTime = this.game.currentState.elapsedTime;
          this.game.stateManager.set('lose');
          this.game.sounds.music.fade(0.3, 0, 1500);
        }
      }
      this.lifeMeshBack.position.copy(this.mesh.position);
      this.lifeMeshBack.position.y += this.height / 2;
      this.lifeMeshBack.position.z -= 0.23;
      this.lifeMesh.position.copy(this.mesh.position);
      this.lifeMesh.position.y += this.height / 2;
      this.lifeMesh.position.z -= 0.23;
      this.lifeMeshScaleTarget = 0.000001 + this.life;
      this.lifeMeshScaleCurrent += (this.lifeMeshScaleTarget - this.lifeMeshScaleCurrent) * 0.2;
      this.lifeMesh.position.x -= (0.3 - 0.3 * this.lifeMeshScaleCurrent) / 2;
      this.lifeMesh.scale.set(this.lifeMeshScaleCurrent, 1, 1);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.game.world.scene.remove(this.light1);
      this.light1 = null;

      this.game.world.scene.remove(this.light2);
      this.light2 = null;

      this.game.world.scene.remove(this.mesh);
      this.geometry.dispose();
      this.material.dispose();
      this.mesh = null;

      this.game.world.scene.remove(this.lifeMesh);
      this.lifeGeometry.dispose();
      this.lifeMaterial.dispose();
      this.lifeMesh = null;

      this.game.world.scene.remove(this.lifeMeshBack);
      this.lifeGeometryBack.dispose();
      this.lifeMaterialBack.dispose();
      this.lifeMeshBack = null;

      this.particleSystem.destroy();
    }
  }, {
    key: 'update',
    value: function update() {
      if (this.game.stateManager.current != 'play' || !this.mesh) {
        return;
      }

      this.move();
      this.updateLights();
      this.collideHeros();
      this.collideFireflies();
      this.updateLightLife();

      this.particleSystem.update();
      //this.particleSystem.particleGroup.position.copy(this.mesh.position);

      this.ghostMesh.position.copy(this.mesh.position);

      if (this.ghostOpacity > 0) {
        this.ghostOpacity -= 0.015;
      }
      var eased = this.ease.inExpo(this.ghostOpacity, 0, 1, 1);
      this.ghostMaterial.opacity = eased;

      var newScale = 1 + eased * 0.5;
      this.ghostMesh.scale.set(newScale, newScale, newScale);
    }
  }]);

  return Hero;
}();

module.exports = Hero;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);
var Calc = __webpack_require__(3);
var Ease = __webpack_require__(4);
var FastSimplexNoise = __webpack_require__(18).default;

var ParticleSystem = function () {
  function ParticleSystem(game, parent, hero, hue) {
    _classCallCheck(this, ParticleSystem);

    this.env = env;
    this.calc = new Calc();
    this.ease = new Ease();
    this.game = game;
    this.parent = parent;
    this.hero = hero;
    this.hue = hue;

    this.particles = [];
    this.particleGroup = new THREE.Object3D();
    this.parent.add(this.particleGroup);

    this.simplex = new FastSimplexNoise();
    this.color = new THREE.Color();

    this.texture = this.generateTexture();
    this.size = 0.25;
    this.base = 12;
    this.count = this.base * this.base * this.base;
    this.geometry = new THREE.BufferGeometry();
    this.parts = [];

    this.positions = new Float32Array(this.count * 3);
    this.colors = new Float32Array(this.count * 4);
    this.sizes = new Float32Array(this.count);

    this.geometry.addAttribute('position', new THREE.BufferAttribute(this.positions, 3));
    this.geometry.addAttribute('color', new THREE.BufferAttribute(this.colors, 4));
    this.geometry.addAttribute('size', new THREE.BufferAttribute(this.sizes, 1));

    for (var i = 0; i < this.count; i++) {
      var size = this.calc.rand(0.02, 0.05);
      this.parts.push({
        offset: 0,
        position: new THREE.Vector3(this.calc.rand(-this.size / 2, this.size / 2) + this.hero.mesh.position.x, this.calc.rand(-this.size / 2, this.size / 2) + this.hero.mesh.position.y, this.calc.rand(-this.size / 2, this.size / 2) + this.hero.mesh.position.z),
        baseSize: size,
        size: size,
        r: 1,
        g: 1,
        b: 1,
        a: 0,
        life: 2,
        decay: this.calc.rand(0.06, 0.09),
        delay: this.calc.randInt(0, 240),
        firstRun: true
      });
    }

    this.material = new THREE.ShaderMaterial({
      uniforms: {
        texture: {
          type: 't',
          value: this.texture
        }
      },
      vertexShader: '\n        attribute float size;\n        attribute vec4 color;\n        varying vec4 vColor;\n        void main() {\n          vColor = color;\n          vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);\n          gl_PointSize = size * (300.0 / length(mvPosition.xyz));\n          gl_Position = projectionMatrix * mvPosition;\n        }\n      ',
      fragmentShader: '\n        uniform sampler2D texture;\n        varying vec4 vColor;\n        void main(void) {\n          vec4 newColor = vColor * texture2D(texture, gl_PointCoord);\n          gl_FragColor = newColor;\n        }\n      ',
      blending: THREE.AdditiveBlending,
      depthTest: false,
      transparent: true
    });

    this.mesh = new THREE.Points(this.geometry, this.material);
    this.mesh.frustumCulled = false;
    this.particleGroup.add(this.mesh);

    this.updateParticleAttributes(true, true, true);
    this.reset();
  }

  _createClass(ParticleSystem, [{
    key: 'reset',
    value: function reset() {}
  }, {
    key: 'generateTexture',
    value: function generateTexture() {
      var c = document.createElement('canvas');
      var ctx = c.getContext('2d');
      var size = 32;
      c.width = size;
      c.height = size;

      var gradient = ctx.createRadialGradient(size * 0.5, size * 0.5, 0, size * 0.5, size * 0.5, size * 0.4);
      gradient.addColorStop(0, 'hsla(0, 0%, 100%, 1)');
      gradient.addColorStop(1, 'hsla(0, 0%, 100%, 0)');

      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      ctx.fillStyle = gradient;
      ctx.fill();

      var texture = new THREE.Texture(c);
      texture.needsUpdate = true;

      return texture;
    }
  }, {
    key: 'updateParticleAttributes',
    value: function updateParticleAttributes(color, position, size) {
      var i = this.count;
      while (i--) {
        var part = this.parts[i];
        if (color) {
          this.colors[i * 4 + 0] = part.r;
          this.colors[i * 4 + 1] = part.g;
          this.colors[i * 4 + 2] = part.b;
          this.colors[i * 4 + 3] = part.a;
        }
        if (position) {
          this.positions[i * 3 + 0] = part.position.x;
          this.positions[i * 3 + 1] = part.position.y;
          this.positions[i * 3 + 2] = part.position.z;
        }
        if (size) {
          this.sizes[i] = part.size;
        }
      }

      if (color) {
        this.geometry.attributes.color.needsUpdate = true;
      }
      if (position) {
        this.geometry.attributes.position.needsUpdate = true;
      }
      if (size) {
        this.geometry.attributes.size.needsUpdate = true;
      }
    }
  }, {
    key: 'replay',
    value: function replay() {
      this.reset();
    }
  }, {
    key: 'update',
    value: function update() {
      var i = this.count;

      var noiseScale = 2;
      var noiseTime = Date.now() * 0.0004;
      var noiseVelocity = 0.03;

      while (i--) {
        var part = this.parts[i];

        part.delay--;
        if (part.delay <= 0) {

          var xScaled = part.position.x * noiseScale;
          var yScaled = part.position.y * noiseScale;
          var zScaled = part.position.z * noiseScale;

          var noise1 = this.simplex.raw4D(xScaled, yScaled, zScaled, noiseTime) * 0.5 + 0.5;
          var noise2 = this.simplex.raw4D(xScaled + 100, yScaled + 100, zScaled + 100, 50 + noiseTime) * 0.5 + 0.5;
          var noise3 = this.simplex.raw4D(xScaled + 200, yScaled + 200, zScaled + 200, 100 + noiseTime) * 0.5 + 0.5;

          part.position.x += Math.sin(noise1 * Math.PI * 2) * noiseVelocity;
          part.position.y += Math.sin(noise2 * Math.PI * 2) * noiseVelocity;
          part.position.z += Math.sin(noise3 * Math.PI * 2) * noiseVelocity;

          if (part.life > 0) {
            part.life -= part.decay * 1;
          }

          if (part.life <= 0 || part.firstRun) {
            part.life = 2;
            var newAngle = this.calc.rand(Math.PI * 2);
            var newMag = this.calc.rand(-this.size / 2, this.size / 2);
            part.position.x = Math.cos(newAngle) * newMag + this.hero.mesh.position.x;
            part.position.y = this.calc.rand(-this.size / 2, this.size / 2) + this.hero.mesh.position.y;
            part.position.z = Math.sin(newAngle) * newMag + this.hero.mesh.position.z;

            var lightness = Math.round(this.calc.rand(10, 50));
            this.color.set('hsl(' + this.hue + ', 85%, ' + lightness + '%)');

            part.r = this.color.r;
            part.g = this.color.g;
            part.b = this.color.b;

            part.firstRun = false;
          }

          part.a = part.life > 1 ? 2 - part.life : part.life;
        }
      }

      this.updateParticleAttributes(true, true, true);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.geometry.dispose();
      this.material.dispose();
      this.parent.remove(this.particleGroup);
      this.mesh = null;
      this.particles.length = null;
    }
  }]);

  return ParticleSystem;
}();

module.exports = ParticleSystem;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

module.exports = "3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3\n3 0 0 3 3 3 0 0 3 3 3 0 0 0 0 0 3 0 2 3\n3 0 0 3 3 0 0 0 0 3 3 0 0 3 3 3 3 0 0 3\n3 3 0 0 3 3 3 0 0 3 3 0 0 3 3 3 0 0 0 3\n3 3 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 3\n3 3 0 0 0 0 0 3 0 0 3 3 3 3 3 3 3 3 0 3\n3 0 0 3 3 3 3 3 0 0 0 3 3 0 0 3 0 0 0 3\n3 0 0 0 0 3 3 3 0 0 0 3 0 0 3 3 3 3 3 3\n3 3 0 0 0 3 3 3 3 0 0 3 3 0 3 3 0 0 0 3\n3 3 0 0 0 3 0 0 0 0 0 0 0 0 3 3 0 0 3 3\n3 0 0 3 3 3 0 0 3 3 0 3 0 0 3 3 0 3 3 3\n3 0 0 3 0 0 0 0 3 3 0 3 0 3 3 3 0 0 0 3\n3 0 0 3 0 0 3 3 3 3 3 3 0 3 0 0 0 0 0 3\n3 3 0 0 0 0 3 3 3 3 0 0 0 0 0 3 3 0 0 3\n3 0 0 3 0 0 3 0 0 3 0 0 0 0 0 3 3 3 0 3\n3 0 3 3 3 3 3 0 0 3 3 3 0 0 3 3 0 0 0 3\n3 0 3 3 0 0 0 0 0 3 3 3 0 0 3 3 0 0 0 3\n3 0 0 0 0 3 0 0 0 0 0 3 0 0 3 3 3 0 0 3\n3 1 0 0 3 3 3 3 3 0 0 0 0 0 3 3 0 0 0 3\n3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3\n"

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseLevel = __webpack_require__(5);
var Level2Data = __webpack_require__(21);

var Level2 = function (_BaseLevel) {
  _inherits(Level2, _BaseLevel);

  function Level2(game, name) {
    _classCallCheck(this, Level2);

    var _this = _possibleConstructorReturn(this, (Level2.__proto__ || Object.getPrototypeOf(Level2)).call(this, game, name));

    _this.maze = Level2Data;
    return _this;
  }

  _createClass(Level2, [{
    key: 'update',
    value: function update() {
      _get(Level2.prototype.__proto__ || Object.getPrototypeOf(Level2.prototype), 'update', this).call(this);
    }
  }]);

  return Level2;
}(BaseLevel);

module.exports = Level2;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3\n3 1 0 0 0 0 3 3 0 0 0 0 3 0 3 3 3 0 0 0 0 2 3\n3 0 0 0 0 0 3 3 0 3 0 0 3 0 0 0 0 0 0 0 0 0 3\n3 3 3 3 3 0 3 3 0 0 0 0 3 0 0 0 0 3 3 3 3 3 3\n3 3 3 3 3 0 0 0 0 3 3 3 3 0 3 3 0 3 0 0 0 0 3\n3 0 0 3 0 0 0 0 0 3 0 0 0 0 3 0 0 0 0 0 3 0 3\n3 0 0 3 0 0 3 3 3 3 0 0 0 0 3 0 0 3 0 3 3 3 3\n3 0 0 0 0 0 3 0 0 3 3 3 3 3 3 3 0 0 0 3 0 0 0\n3 0 0 0 0 0 0 0 0 0 0 3 0 0 3 3 0 0 3 3 0 0 0\n3 3 3 3 3 0 0 3 3 3 3 3 0 0 0 0 0 0 0 3 3 3 3\n0 0 0 3 0 0 0 3 3 0 0 3 0 0 0 0 0 0 0 3 0 0 3\n0 0 0 3 0 0 0 0 3 0 0 3 3 3 3 3 3 0 0 3 0 0 3\n0 0 0 3 3 3 0 0 0 0 0 0 0 0 0 0 3 0 0 0 0 3 3\n3 3 3 3 3 3 0 0 0 3 3 0 0 0 0 3 3 0 0 0 0 0 3\n3 0 3 0 0 0 0 0 3 3 3 3 0 0 3 3 3 0 0 3 0 0 3\n3 0 3 3 0 0 3 0 3 0 0 3 0 0 0 0 0 0 0 3 0 0 3\n3 0 0 0 0 0 0 0 3 0 0 3 0 0 3 0 0 0 0 3 0 3 3\n3 0 0 0 3 0 0 0 0 0 0 3 0 0 3 3 0 3 0 3 0 3 3\n3 0 0 0 3 3 3 3 3 0 0 0 0 0 0 3 0 0 0 3 3 3 3\n3 3 3 0 3 3 3 3 3 3 0 0 3 3 3 3 3 3 3 3 0 0 0\n0 0 3 0 3 0 0 3 0 0 0 0 0 0 0 0 0 0 0 3 0 0 0\n0 0 3 0 3 0 0 3 0 0 0 3 3 3 0 0 0 0 0 3 0 0 0\n0 0 3 3 3 0 0 3 3 3 3 3 3 3 3 3 3 3 3 3 0 0 0\n"

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseLevel = __webpack_require__(5);
var Level3Data = __webpack_require__(23);

var Level3 = function (_BaseLevel) {
  _inherits(Level3, _BaseLevel);

  function Level3(game, name) {
    _classCallCheck(this, Level3);

    var _this = _possibleConstructorReturn(this, (Level3.__proto__ || Object.getPrototypeOf(Level3)).call(this, game, name));

    _this.maze = Level3Data;
    return _this;
  }

  _createClass(Level3, [{
    key: 'update',
    value: function update() {
      _get(Level3.prototype.__proto__ || Object.getPrototypeOf(Level3.prototype), 'update', this).call(this);
    }
  }]);

  return Level3;
}(BaseLevel);

module.exports = Level3;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3\n3 0 0 0 0 0 3 3 3 0 0 3 0 0 3 0 0 0 0 3 0 0 0 0 0 3\n3 0 3 0 0 0 0 0 0 0 0 3 0 0 3 3 3 0 0 0 0 0 0 3 0 3\n3 3 0 0 3 3 3 3 0 0 0 3 0 0 0 0 3 0 0 3 3 3 0 0 0 3\n3 3 0 0 3 0 0 0 0 3 0 3 0 0 0 0 0 0 0 0 0 3 0 0 0 3\n3 3 3 0 3 0 0 0 0 3 0 3 0 3 0 0 0 0 3 0 0 3 0 3 0 3\n3 0 0 0 3 3 3 3 3 3 0 3 0 3 0 0 0 3 0 0 0 3 0 3 3 3\n3 0 0 0 0 0 0 0 0 3 0 3 3 3 0 0 3 0 0 0 0 3 0 0 0 3\n3 0 3 0 0 3 0 0 0 3 0 3 0 0 0 3 0 0 3 3 3 3 0 0 0 3\n3 0 3 3 3 3 1 3 3 3 0 0 0 0 3 0 0 3 0 0 0 3 0 0 0 3\n3 0 3 0 3 3 3 3 3 3 0 0 0 3 0 0 0 3 0 0 0 3 3 0 0 3\n3 0 3 0 3 0 0 0 0 3 0 3 3 3 0 3 3 3 0 0 0 3 3 0 0 3\n3 0 3 0 0 3 0 0 0 3 0 0 0 0 3 0 0 0 0 0 3 0 0 0 3 3\n3 0 0 3 0 0 3 0 0 3 3 3 3 0 3 3 3 0 0 3 0 0 0 3 3 3\n3 0 0 0 3 0 0 3 0 0 0 0 3 0 0 0 0 0 3 0 0 0 0 0 0 3\n3 3 0 0 3 3 0 0 3 0 0 0 3 0 3 3 3 3 3 3 3 3 0 0 0 3\n3 3 0 0 0 0 3 0 0 3 0 0 0 0 0 0 3 0 0 0 0 0 0 3 0 3\n3 0 0 0 0 0 0 3 0 3 3 3 0 3 3 0 3 0 0 0 3 0 0 0 0 3\n3 0 0 3 0 0 0 3 0 0 0 3 0 3 3 0 3 3 3 2 3 0 0 0 3 3\n3 0 0 3 3 3 3 3 3 0 0 3 0 0 0 0 3 3 3 3 3 3 0 0 0 3\n3 3 0 3 0 0 0 0 3 0 0 3 0 0 0 0 3 0 0 0 0 3 0 0 0 3\n3 3 0 3 0 0 0 3 3 0 0 3 0 3 0 0 0 3 3 0 0 3 0 0 0 3\n3 0 0 3 0 0 3 3 0 0 3 0 0 0 3 0 0 0 3 3 0 0 0 3 3 3\n3 0 3 3 0 0 3 0 0 3 0 0 0 0 0 3 0 0 0 3 0 0 0 0 0 3\n3 0 0 0 0 0 0 0 0 0 0 3 3 3 0 0 3 0 0 0 0 3 0 0 0 3\n3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3\n"

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseLevel = __webpack_require__(5);
var Level4Data = __webpack_require__(25);

var Level4 = function (_BaseLevel) {
  _inherits(Level4, _BaseLevel);

  function Level4(game, name) {
    _classCallCheck(this, Level4);

    var _this = _possibleConstructorReturn(this, (Level4.__proto__ || Object.getPrototypeOf(Level4)).call(this, game, name));

    _this.maze = Level4Data;
    return _this;
  }

  _createClass(Level4, [{
    key: 'update',
    value: function update() {
      _get(Level4.prototype.__proto__ || Object.getPrototypeOf(Level4.prototype), 'update', this).call(this);
    }
  }]);

  return Level4;
}(BaseLevel);

module.exports = Level4;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = "3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3\n3 0 0 0 3 0 0 0 0 0 0 0 0 3 0 3 3 3 0 0 0 0 0 0 3 0 0 3 3\n3 3 0 0 0 0 3 3 0 3 3 3 3 3 0 3 0 0 0 0 3 3 3 0 3 0 0 3 3\n3 3 3 3 3 0 3 3 0 0 0 3 3 0 0 3 3 3 3 3 3 0 3 0 3 3 0 0 3\n3 0 3 0 3 0 3 0 0 0 3 3 0 0 0 0 3 0 0 0 0 0 3 0 0 3 3 0 3\n3 0 0 0 0 0 0 0 3 0 0 3 3 3 0 0 3 3 3 0 0 3 3 0 0 3 0 0 3\n3 0 3 0 0 3 3 3 3 3 0 3 0 3 3 0 0 3 3 0 3 3 0 0 3 3 0 0 3\n3 0 3 0 3 3 0 3 3 0 0 0 0 0 3 3 0 0 3 0 3 0 0 3 3 0 0 3 3\n3 3 3 0 3 3 0 0 0 0 3 3 3 0 0 3 0 0 3 0 0 0 0 0 0 0 0 3 3\n3 3 3 0 0 3 3 3 3 0 0 0 3 3 3 3 3 0 3 0 0 3 3 3 3 0 0 3 3\n3 0 0 0 0 0 0 3 0 3 0 0 3 0 3 3 3 0 3 0 0 3 0 0 0 0 0 3 3\n3 0 3 0 3 3 0 3 0 3 0 3 3 0 0 0 3 0 0 0 3 0 0 3 3 3 0 3 3\n3 0 3 0 3 0 0 3 0 3 0 0 0 0 3 0 0 0 0 3 0 0 3 0 0 3 0 3 3\n3 0 3 0 3 3 3 3 0 3 3 3 3 3 3 3 3 3 3 3 0 3 0 0 0 3 0 0 3\n3 0 3 0 0 3 3 0 0 0 0 0 0 0 3 0 2 3 3 3 0 3 3 3 0 3 0 0 3\n3 3 3 0 0 0 0 0 3 0 3 3 0 1 3 0 0 0 0 0 0 0 0 0 0 3 0 3 3\n3 0 0 0 3 3 0 0 3 0 3 3 3 3 3 3 3 3 3 0 0 3 3 3 0 0 0 0 3\n3 0 3 3 0 3 3 3 3 0 3 0 0 3 3 0 3 0 3 3 0 0 3 3 0 3 3 0 3\n3 0 3 0 0 0 3 0 3 0 0 0 0 0 3 0 3 0 3 3 0 0 3 3 0 3 0 0 3\n3 0 3 0 3 0 3 0 0 0 0 3 0 0 0 0 3 0 0 3 3 0 0 3 0 3 3 3 3\n3 0 3 0 3 0 0 0 3 0 3 3 3 3 3 0 3 3 0 0 3 3 0 0 0 0 0 0 3\n3 0 3 3 3 3 0 3 0 0 3 3 0 0 3 0 0 3 0 0 0 3 3 3 3 3 3 0 3\n3 0 3 0 3 0 0 3 3 0 3 0 0 3 3 0 0 0 0 3 3 0 0 0 0 0 3 0 3\n3 0 0 0 3 0 0 0 3 0 3 0 0 0 3 3 3 0 3 3 0 0 3 0 3 0 3 0 3\n3 0 3 3 3 0 3 0 3 0 3 0 3 0 3 3 0 0 3 0 0 3 0 0 3 0 3 0 3\n3 0 3 0 0 0 3 0 3 3 3 0 3 0 3 0 3 0 3 0 3 0 0 3 3 3 3 0 3\n3 0 3 3 3 3 3 0 0 0 0 0 3 0 0 0 3 0 0 0 3 3 0 0 3 0 0 0 3\n3 0 0 0 0 0 0 0 3 3 3 0 3 0 0 0 3 3 0 3 3 3 3 0 0 0 0 3 3\n3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3 3\n"

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);
var InstructionsState = __webpack_require__(27);
var LoseState = __webpack_require__(29);
var MenuState = __webpack_require__(30);
var PlayState = __webpack_require__(31);
var WinState = __webpack_require__(32);

var StateManager = function () {
  function StateManager(game) {
    _classCallCheck(this, StateManager);

    this.env = env;
    this.game = game;
    this.states = {
      instructions: new InstructionsState(this.game, 'instructions'),
      lose: new LoseState(this.game, 'lose'),
      menu: new MenuState(this.game, 'menu'),
      play: new PlayState(this.game, 'play'),
      win: new WinState(this.game, 'win')
    };
  }

  _createClass(StateManager, [{
    key: 'set',
    value: function set(state) {
      if (this.current) {
        this.states[this.current].deactivate();
      }
      this.current = state;
      this.states[this.current].activate();
    }
  }]);

  return StateManager;
}();

module.exports = StateManager;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseState = __webpack_require__(2);

var InstructionsState = function (_BaseState) {
  _inherits(InstructionsState, _BaseState);

  function InstructionsState(game, name) {
    _classCallCheck(this, InstructionsState);

    return _possibleConstructorReturn(this, (InstructionsState.__proto__ || Object.getPrototypeOf(InstructionsState)).call(this, game, name));
  }

  _createClass(InstructionsState, [{
    key: 'setupDOM',
    value: function setupDOM() {
      _get(InstructionsState.prototype.__proto__ || Object.getPrototypeOf(InstructionsState.prototype), 'setupDOM', this).call(this);
    }
  }, {
    key: 'observe',
    value: function observe() {
      var _this2 = this;

      _get(InstructionsState.prototype.__proto__ || Object.getPrototypeOf(InstructionsState.prototype), 'observe', this).call(this);
      this.dom.state.addEventListener('click', function (e) {
        return _this2.onClick(e);
      });
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.game.sounds.button.play();
      this.game.stateManager.set('play');
    }
  }, {
    key: 'activate',
    value: function activate() {
      _get(InstructionsState.prototype.__proto__ || Object.getPrototypeOf(InstructionsState.prototype), 'activate', this).call(this);
      this.tick = 0;
      this.tickMax = 60 * 20;
    }
  }, {
    key: 'update',
    value: function update() {
      _get(InstructionsState.prototype.__proto__ || Object.getPrototypeOf(InstructionsState.prototype), 'update', this).call(this);
      if (!this.isActive) {
        return;
      }
      // this.tick++;
      // if(this.tick === this.tickMax) {
      //   this.game.stateManager.set('play');
      // }
    }
  }]);

  return InstructionsState;
}(BaseState);

module.exports = InstructionsState;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Utils = function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }

  _createClass(Utils, [{
    key: 'pad',
    value: function pad(amount, digits) {
      amount += '';
      if (amount.length < digits) {
        amount = '0' + amount;
        return this.pad(amount, digits);
      } else {
        return amount;
      }
    }
  }, {
    key: 'msToString',
    value: function msToString(ms) {
      var x = ms / 1000;
      var seconds = parseInt(x % 60);
      x /= 60;
      var minutes = parseInt(x % 60);

      return minutes + ':' + this.pad(seconds, 2);
    }
  }]);

  return Utils;
}();

module.exports = Utils;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseState = __webpack_require__(2);

var LoseState = function (_BaseState) {
  _inherits(LoseState, _BaseState);

  function LoseState(game, name) {
    _classCallCheck(this, LoseState);

    return _possibleConstructorReturn(this, (LoseState.__proto__ || Object.getPrototypeOf(LoseState)).call(this, game, name));
  }

  _createClass(LoseState, [{
    key: 'setupDOM',
    value: function setupDOM() {
      _get(LoseState.prototype.__proto__ || Object.getPrototypeOf(LoseState.prototype), 'setupDOM', this).call(this);
      this.dom.title = document.querySelector('.state-lose-title');
      this.dom.info = document.querySelector('.state-lose-info');
    }
  }, {
    key: 'observe',
    value: function observe() {
      var _this2 = this;

      _get(LoseState.prototype.__proto__ || Object.getPrototypeOf(LoseState.prototype), 'observe', this).call(this);
      this.dom.state.addEventListener('click', function (e) {
        return _this2.onClick(e);
      });
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.game.sounds.button.play();
      this.game.stateManager.set('menu');
    }
  }, {
    key: 'activate',
    value: function activate() {
      _get(LoseState.prototype.__proto__ || Object.getPrototypeOf(LoseState.prototype), 'activate', this).call(this);
      this.tick = 0;
      this.tickMax = 60 * 5;

      // set level corresponding dialogue
      var newTitle = null;
      if (this.game.lastLevelPlayed === 'level1') {
        newTitle = 'Mary and Zoey lost their light and couldn’t<br> find each other, or their way out.';
      }
      if (this.game.lastLevelPlayed === 'level2') {
        newTitle = 'As their light source depleted, so did <br>Zoey and Mary’s chance to survive.';
      }
      if (this.game.lastLevelPlayed === 'level3') {
        newTitle = 'Mary and Zoey were overwhelmed by the <br>darkness and couldn’t find safety.';
      }
      if (this.game.lastLevelPlayed === 'level4') {
        newTitle = 'Alone and lost in the dark, Mary and Zoey were unable to navigate to safety, and succumbed to this scary, dark place.';
      }
      this.dom.title.innerHTML = newTitle;

      // set info
      this.dom.info.innerHTML = 'Level ' + (this.game.levelManager.levelNames.indexOf(this.game.lastLevelPlayed) + 1) + ' Failed<br><span>' + this.utils.msToString(this.game.lastLevelTime) + '</span>';

      var levelStorage = this.env.storage.get(this.game.lastLevelPlayed);
      levelStorage.timesPlayed++;
      this.env.storage.set(this.game.lastLevelPlayed, levelStorage);
    }
  }, {
    key: 'update',
    value: function update() {
      _get(LoseState.prototype.__proto__ || Object.getPrototypeOf(LoseState.prototype), 'update', this).call(this);
      if (!this.isActive) {
        return;
      }
      // this.tick++;
      // if(this.tick === this.tickMax) {
      //   this.game.stateManager.set('menu');
      // }
    }
  }]);

  return LoseState;
}(BaseState);

module.exports = LoseState;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseState = __webpack_require__(2);

var MenuState = function (_BaseState) {
  _inherits(MenuState, _BaseState);

  function MenuState(game, name) {
    _classCallCheck(this, MenuState);

    return _possibleConstructorReturn(this, (MenuState.__proto__ || Object.getPrototypeOf(MenuState)).call(this, game, name));
  }

  _createClass(MenuState, [{
    key: 'setupDOM',
    value: function setupDOM() {
      _get(MenuState.prototype.__proto__ || Object.getPrototypeOf(MenuState.prototype), 'setupDOM', this).call(this);
      this.dom.levels = document.querySelectorAll('.state-menu-level');

      this.dom.level1 = document.querySelector('.state-menu-level-1');
      this.dom.level2 = document.querySelector('.state-menu-level-2');
      this.dom.level3 = document.querySelector('.state-menu-level-3');
      this.dom.level4 = document.querySelector('.state-menu-level-4');

      this.dom.level1Time = document.querySelector('.state-menu-level-1-time');
      this.dom.level2Time = document.querySelector('.state-menu-level-2-time');
      this.dom.level3Time = document.querySelector('.state-menu-level-3-time');
      this.dom.level4Time = document.querySelector('.state-menu-level-4-time');
    }
  }, {
    key: 'observe',
    value: function observe() {
      var _this2 = this;

      _get(MenuState.prototype.__proto__ || Object.getPrototypeOf(MenuState.prototype), 'observe', this).call(this);

      var _loop = function _loop(i, len) {
        var levelElem = _this2.dom.levels[i];
        var name = levelElem.getAttribute('data-name');
        levelElem.addEventListener('click', function () {
          if (_this2.env.storage.get(name).available || location.href.indexOf('debug') > -1) {
            _this2.game.sounds.button.play();
            _this2.game.currentLevel = name;
            if (name === 'level1') {
              _this2.game.stateManager.set('instructions');
            } else {
              _this2.game.stateManager.set('play');
            }
          }
        });
      };

      for (var i = 0, len = this.dom.levels.length; i < len; i++) {
        _loop(i, len);
      }
    }
  }, {
    key: 'activate',
    value: function activate() {
      _get(MenuState.prototype.__proto__ || Object.getPrototypeOf(MenuState.prototype), 'activate', this).call(this);
      this.updateLevelDOM();
    }
  }, {
    key: 'updateLevelDOM',
    value: function updateLevelDOM() {
      var level1 = this.env.storage.get('level1');
      if (level1.available) {
        this.dom.level1.classList.add('state-menu-level-available');
      } else {
        this.dom.level1.classList.remove('state-menu-level-available');
      }
      if (level1.beaten) {
        this.dom.level1.classList.add('state-menu-level-beaten');
      } else {
        this.dom.level1.classList.remove('state-menu-level-beaten');
      }
      if (level1.bestTime) {
        this.dom.level1Time.textContent = this.utils.msToString(level1.bestTime);
      }

      var level2 = this.env.storage.get('level2');
      if (level2.available) {
        this.dom.level2.classList.add('state-menu-level-available');
      } else {
        this.dom.level2.classList.remove('state-menu-level-available');
      }
      if (level2.beaten) {
        this.dom.level2.classList.add('state-menu-level-beaten');
      } else {
        this.dom.level2.classList.remove('state-menu-level-beaten');
      }
      if (level2.bestTime) {
        this.dom.level2Time.textContent = this.utils.msToString(level2.bestTime);
      }

      var level3 = this.env.storage.get('level3');
      if (level3.available) {
        this.dom.level3.classList.add('state-menu-level-available');
      } else {
        this.dom.level3.classList.remove('state-menu-level-available');
      }
      if (level3.beaten) {
        this.dom.level3.classList.add('state-menu-level-beaten');
      } else {
        this.dom.level3.classList.remove('state-menu-level-beaten');
      }
      if (level3.bestTime) {
        this.dom.level3Time.textContent = this.utils.msToString(level3.bestTime);
      }

      var level4 = this.env.storage.get('level4');
      if (level4.available) {
        this.dom.level4.classList.add('state-menu-level-available');
      } else {
        this.dom.level4.classList.remove('state-menu-level-available');
      }
      if (level4.beaten) {
        this.dom.level4.classList.add('state-menu-level-beaten');
      } else {
        this.dom.level4.classList.remove('state-menu-level-beaten');
      }
      if (level4.bestTime) {
        this.dom.level4Time.textContent = this.utils.msToString(level4.bestTime);
      }
    }
  }, {
    key: 'update',
    value: function update() {
      _get(MenuState.prototype.__proto__ || Object.getPrototypeOf(MenuState.prototype), 'update', this).call(this);
      if (!this.isActive) {
        return;
      }
    }
  }]);

  return MenuState;
}(BaseState);

module.exports = MenuState;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseState = __webpack_require__(2);

var PlayState = function (_BaseState) {
  _inherits(PlayState, _BaseState);

  function PlayState(game, name) {
    _classCallCheck(this, PlayState);

    return _possibleConstructorReturn(this, (PlayState.__proto__ || Object.getPrototypeOf(PlayState)).call(this, game, name));
  }

  _createClass(PlayState, [{
    key: 'activate',
    value: function activate() {
      _get(PlayState.prototype.__proto__ || Object.getPrototypeOf(PlayState.prototype), 'activate', this).call(this);
      this.reset();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.game.levelManager.set(this.game.currentLevel);

      this.flashOpacity = 0;

      this.switchTime = 0;
      this.switchTimeMax = 6000;

      this.dom.levelTitle.textContent = 'Level ' + (this.game.levelManager.levelNames.indexOf(this.game.currentLevel) + 1);

      this.game.isPlaying = false;
      this.game.isEnding = false;

      this.game.sounds.levelIntro.rate(0.5);
      this.game.sounds.levelIntro.play();

      this.showMaryDialog();

      this.env.eventful.trigger('play-reset');
    }
  }, {
    key: 'setupDOM',
    value: function setupDOM() {
      _get(PlayState.prototype.__proto__ || Object.getPrototypeOf(PlayState.prototype), 'setupDOM', this).call(this);

      this.dom.levelTitle = document.querySelector('.state-play-level-title');
      this.dom.levelTime = document.querySelector('.state-play-level-time');
      this.dom.heroAWrap = document.querySelector('.state-play-hero-a-wrap');
      this.dom.heroBWrap = document.querySelector('.state-play-hero-b-wrap');
      this.dom.heroAMeterLightBar = document.querySelector('.state-play-hero-a-meter-light-bar');
      this.dom.heroBMeterLightBar = document.querySelector('.state-play-hero-b-meter-light-bar');
      this.dom.heroAMeterTimeBar = document.querySelector('.state-play-hero-a-meter-time-bar');
      this.dom.heroBMeterTimeBar = document.querySelector('.state-play-hero-b-meter-time-bar');
      this.dom.dialog = document.querySelector('.state-play-dialog');
    }
  }, {
    key: 'observe',
    value: function observe() {
      var _this2 = this;

      _get(PlayState.prototype.__proto__ || Object.getPrototypeOf(PlayState.prototype), 'observe', this).call(this);
      this.env.eventful.on('unite', function (e) {
        return _this2.startEnd(e);
      });
    }
  }, {
    key: 'switchHero',
    value: function switchHero() {
      if (!this.isActive || this.game.isEnding) {
        return;
      }
      if (this.game.heroA.isActive) {
        this.game.heroB.setActive(true);
        this.game.heroA.setActive(false);
        this.game.activeHero = this.game.heroB;
        this.dom.heroAWrap.classList.remove('state-play-hero-wrap-active');
        this.dom.heroBWrap.classList.add('state-play-hero-wrap-active');
      } else {
        this.game.heroA.setActive(true);
        this.game.heroB.setActive(false);
        this.game.activeHero = this.game.heroA;
        this.dom.heroAWrap.classList.add('state-play-hero-wrap-active');
        this.dom.heroBWrap.classList.remove('state-play-hero-wrap-active');
      }
      this.game.sounds.switch.play();
    }
  }, {
    key: 'showMaryDialog',
    value: function showMaryDialog() {
      var _this3 = this;

      setTimeout(function () {
        _this3.game.sounds.mary.play();
      }, 1500);

      this.game.heroA.setActive(true);
      this.game.activeHero = this.game.heroA;
      this.dom.heroAWrap.classList.add('state-play-hero-wrap-active');
      this.dom.heroBWrap.classList.remove('state-play-hero-wrap-active');

      var dialog = null;
      if (this.game.currentLevel === 'level1') {
        dialog = '<span>Mary:</span> What is this place?';
      }
      if (this.game.currentLevel === 'level2') {
        dialog = '<span>Mary:</span> Where are you, Zoey?';
      }
      if (this.game.currentLevel === 'level3') {
        dialog = '<span>Mary:</span> Why are we always getting lost?';
      }
      if (this.game.currentLevel === 'level4') {
        dialog = '<span>Mary:</span> Again?! Is this real life?';
      }

      this.dom.dialog.innerHTML = dialog;
      setTimeout(function () {
        _this3.dom.dialog.classList.add('state-play-dialog-active');
      }, 1500);

      this.dom.dialog.classList.remove('state-play-dialog-b');
      this.dom.dialog.classList.add('state-play-dialog-a');

      setTimeout(function () {
        _this3.hideMaryDialog();
      }, 2500);
    }
  }, {
    key: 'hideMaryDialog',
    value: function hideMaryDialog() {
      var _this4 = this;

      this.dom.dialog.classList.remove('state-play-dialog-active');

      setTimeout(function () {
        _this4.showZoeyDialog();
      }, 500);
    }
  }, {
    key: 'showZoeyDialog',
    value: function showZoeyDialog() {
      var _this5 = this;

      setTimeout(function () {
        _this5.game.sounds.zoey.play();
      }, 1200);

      // setTimeout(() => {
      //   this.game.sounds.levelIntro.rate(0.7);
      //   this.game.sounds.levelIntro.play();
      // }, 750);

      this.game.heroA.setActive(false);
      this.game.heroB.setActive(true);
      this.game.activeHero = this.game.heroB;
      this.dom.heroAWrap.classList.remove('state-play-hero-wrap-active');
      this.dom.heroBWrap.classList.add('state-play-hero-wrap-active');

      var dialog = null;
      if (this.game.currentLevel === 'level1') {
        dialog = '<span>Zoey:</span> It’s so dark...';
      }
      if (this.game.currentLevel === 'level2') {
        dialog = '<span>Zoey:</span> I’m scared!';
      }
      if (this.game.currentLevel === 'level3') {
        dialog = '<span>Zoey:</span> We’ve gotta stop losing each other, Mary...';
      }
      if (this.game.currentLevel === 'level4') {
        dialog = '<span>Zoey:</span> I think I can hear you!';
      }

      this.dom.dialog.innerHTML = dialog;
      setTimeout(function () {
        _this5.dom.dialog.classList.add('state-play-dialog-active');
      }, 1000);

      this.dom.dialog.classList.remove('state-play-dialog-a');
      this.dom.dialog.classList.add('state-play-dialog-b');

      setTimeout(function () {
        _this5.hideZoeyDialog();
      }, 2500);
    }
  }, {
    key: 'hideZoeyDialog',
    value: function hideZoeyDialog() {
      var _this6 = this;

      this.dom.dialog.classList.remove('state-play-dialog-active');

      setTimeout(function () {
        _this6.startPlay();
      }, 500);
    }
  }, {
    key: 'startPlay',
    value: function startPlay() {
      var _this7 = this;

      this.game.isPlaying = true;

      this.game.heroB.setActive(false);
      this.game.heroA.setActive(true);
      this.game.activeHero = this.game.heroA;
      this.dom.heroAWrap.classList.add('state-play-hero-wrap-active');
      this.dom.heroBWrap.classList.remove('state-play-hero-wrap-active');

      this.nowTime = Date.now();
      this.startTime = this.nowTime;
      this.oldTime = this.nowTime;
      this.elapsedTime = 0;
      this.deltaTime = 0;

      setTimeout(function () {
        _this7.game.sounds.music.stop();
        _this7.game.sounds.music.volume(0.3);
        _this7.game.sounds.music.play();
        //this.game.sounds.music.fade(0, 0.3, 500);
      }, 1200);
    }
  }, {
    key: 'startEnd',
    value: function startEnd() {
      this.game.isEnding = true;
      this.endTick = 0;
      this.endTickMax = 60 * 1.5;
      this.game.sounds.music.fade(0.3, 0, 3000);
      //this.game.sounds.music.stop();
    }
  }, {
    key: 'update',
    value: function update() {
      _get(PlayState.prototype.__proto__ || Object.getPrototypeOf(PlayState.prototype), 'update', this).call(this);
      if (!this.isActive) {
        return;
      }

      if (this.game.isPlaying) {
        this.nowTime = Date.now();
        this.deltaTime = this.nowTime - this.oldTime;
        this.elapsedTime = this.nowTime - this.startTime;
        this.oldTime = this.nowTime;
        this.dom.levelTime.textContent = this.utils.msToString(this.elapsedTime);
      }

      if (this.game.isPlaying) {
        this.switchTime += this.deltaTime;
        if (this.switchTime >= this.switchTimeMax) {
          this.switchHero();
          this.switchTime = this.switchTime - this.switchTimeMax;
        }
      }

      this.dom.heroAMeterLightBar.style.transform = 'scaleX(' + this.game.heroA.life + ')';
      this.dom.heroBMeterLightBar.style.transform = 'scaleX(' + this.game.heroB.life + ')';

      if (this.game.heroA.isActive) {
        this.dom.heroAMeterTimeBar.style.transform = 'scaleX(' + (1 - this.switchTime / this.switchTimeMax) + ')';
        this.dom.heroBMeterTimeBar.style.transform = 'scaleX(1)';
      } else {
        this.dom.heroAMeterTimeBar.style.transform = 'scaleX(1)';
        this.dom.heroBMeterTimeBar.style.transform = 'scaleX(' + (1 - this.switchTime / this.switchTimeMax) + ')';
      }

      if (this.game.isEnding) {
        this.endTick++;
        this.env.eventful.trigger('end-tick', { prog: this.endTick / this.endTickMax });
        if (this.endTick >= this.endTickMax) {
          this.game.stateManager.set('win');
        }
      }
    }
  }]);

  return PlayState;
}(BaseState);

module.exports = PlayState;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseState = __webpack_require__(2);

var WinState = function (_BaseState) {
  _inherits(WinState, _BaseState);

  function WinState(game, name) {
    _classCallCheck(this, WinState);

    return _possibleConstructorReturn(this, (WinState.__proto__ || Object.getPrototypeOf(WinState)).call(this, game, name));
  }

  _createClass(WinState, [{
    key: 'setupDOM',
    value: function setupDOM() {
      _get(WinState.prototype.__proto__ || Object.getPrototypeOf(WinState.prototype), 'setupDOM', this).call(this);
      this.dom.title = document.querySelector('.state-win-title');
      this.dom.info = document.querySelector('.state-win-info');
    }
  }, {
    key: 'observe',
    value: function observe() {
      var _this2 = this;

      _get(WinState.prototype.__proto__ || Object.getPrototypeOf(WinState.prototype), 'observe', this).call(this);
      this.dom.state.addEventListener('click', function (e) {
        return _this2.onClick(e);
      });
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.game.sounds.button.play();
      this.game.stateManager.set('menu');
    }
  }, {
    key: 'activate',
    value: function activate() {
      _get(WinState.prototype.__proto__ || Object.getPrototypeOf(WinState.prototype), 'activate', this).call(this);
      this.tick = 0;
      this.tickMax = 60 * 5;

      // set level corresponding dialogue
      var newTitle = null;
      if (this.game.lastLevelPlayed === 'level1') {
        newTitle = 'Together, <span>Mary</span> and <span>Zoey</span> were able to find their way out.';
      }
      if (this.game.lastLevelPlayed === 'level2') {
        newTitle = '<span>Mary</span> and <span>Zoey</span> escaped safely, once again.';
      }
      if (this.game.lastLevelPlayed === 'level3') {
        newTitle = '<span>Mary</span> and <span>Zoey</span>, now feeling skilled at navigating dark, scary places, were able to reunite once again.';
      }
      if (this.game.lastLevelPlayed === 'level4') {
        newTitle = 'Overcoming their hopelessness, <span>Mary</span> and <span>Zoey</span> found each other once more and were finally able to conquer the darkness... or did they?';
      }
      this.dom.title.innerHTML = newTitle;

      // set info
      this.dom.info.innerHTML = 'Level ' + (this.game.levelManager.levelNames.indexOf(this.game.lastLevelPlayed) + 1) + ' Complete<br><span>' + this.utils.msToString(this.game.lastLevelTime) + '</span>';

      // increase times played
      var levelStorage = this.env.storage.get(this.game.lastLevelPlayed);
      levelStorage.timesPlayed++;
      this.env.storage.set(this.game.lastLevelPlayed, levelStorage);

      // set level to beaten status
      levelStorage = this.env.storage.get(this.game.lastLevelPlayed);
      levelStorage.beaten = true;
      this.env.storage.set(this.game.lastLevelPlayed, levelStorage);

      // check the best time
      levelStorage = this.env.storage.get(this.game.lastLevelPlayed);
      if (levelStorage.bestTime) {
        levelStorage.bestTime = Math.min(this.game.lastLevelTime, levelStorage.bestTime);
      } else {
        levelStorage.bestTime = this.game.lastLevelTime;
      }
      this.env.storage.set(this.game.lastLevelPlayed, levelStorage);

      // set next level to available
      levelStorage = this.env.storage.get(this.game.lastLevelPlayed);
      var currIndex = levelStorage.index;
      if (currIndex < 3) {
        var nextIndex = currIndex + 2;
        var nextLevelStorage = this.env.storage.get('level' + nextIndex);
        nextLevelStorage.available = true;
        this.env.storage.set('level' + nextIndex, nextLevelStorage);
      }
    }
  }, {
    key: 'update',
    value: function update() {
      _get(WinState.prototype.__proto__ || Object.getPrototypeOf(WinState.prototype), 'update', this).call(this);
      if (!this.isActive) {
        return;
      }
      // this.tick++;
      // if(this.tick === this.tickMax) {
      //   this.game.stateManager.set('menu');
      // }
    }
  }]);

  return WinState;
}(BaseState);

module.exports = WinState;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);

var Time = function () {
  function Time(game) {
    _classCallCheck(this, Time);

    this.env = env;
    this.game = game;

    this.timescale = 1;
    this.clock = new THREE.Clock();
    this.dts = this.clock.getDelta() * this.timescale;
    this.dtms = this.dts * 1000;
    this.dtn = this.dtms / (1000 / 60);
    this.em = 0;

    this.observe();
  }

  _createClass(Time, [{
    key: 'observe',
    value: function observe() {
      var _this = this;

      this.env.eventful.on('game-animate', function (e) {
        return _this.update(e);
      });
    }
  }, {
    key: 'update',
    value: function update() {
      this.dts = this.clock.getDelta();
      this.dts *= this.timescale;
      this.dtm = this.dts * 1000;
      this.dtn = this.dtm / (1000 / 60);
      this.em += this.dtm;
    }
  }]);

  return Time;
}();

module.exports = Time;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var env = __webpack_require__(1);

__webpack_require__(35);
__webpack_require__(36);
__webpack_require__(37);
__webpack_require__(38);
__webpack_require__(39);
__webpack_require__(40);
__webpack_require__(41);
__webpack_require__(42);
__webpack_require__(43);
__webpack_require__(44);
__webpack_require__(45);
__webpack_require__(46);
__webpack_require__(47);

var World = function () {
  function World(init) {
    _classCallCheck(this, World);

    this.env = env;

    this.game = init.game;

    this.observe();
    this.setupScene();
    this.setupLights();
    this.setupRenderer();
    this.setupCameras();
    this.setupComposer();
    this.setupGrid();

    this.cameraLift = 0;
  }

  _createClass(World, [{
    key: 'observe',
    value: function observe() {
      var _this = this;

      this.env.eventful.on('game-resize', function (e) {
        return _this.onGameResize(e);
      });
      this.env.eventful.on('game-animate', function () {
        return _this.onGameAnimate();
      });
      this.env.eventful.on('collect-firefly', function () {
        return _this.smallFlash();
      });
      this.env.eventful.on('end-tick', function (e) {
        return _this.endTick(e);
      });
      this.env.eventful.on('play-reset', function () {
        return _this.playReset();
      });
    }
  }, {
    key: 'smallFlash',
    value: function smallFlash() {
      this.brightnessValue = 0.03;
    }
  }, {
    key: 'endTick',
    value: function endTick(e) {
      this.brightnessValue = e.prog * 0.75;
      this.cameraLift = 3 + e.prog * 100;
    }
  }, {
    key: 'playReset',
    value: function playReset() {
      this.brightnessValue = 0;
      this.cameraLift = 3;

      // this.cameraCurrent.copy(this.game.activeHero.mesh.position);
      // this.cameraTarget.copy(this.game.activeHero.mesh.position);
      // this.cameraCurrent.y += 100;
      // this.cameraTarget.y += 100;
      // this.cameraLookAtCurrent.copy(this.game.activeHero.mesh.position);
      // this.cameraLookAtTarget.copy(this.game.activeHero.mesh.position);

      this.cameraCurrent.set(0, 0, 0);
      this.cameraTarget.set(0, 0, 0);
      this.cameraCurrent.y += 100;
      this.cameraTarget.y += 100;
      this.cameraLookAtCurrent.set(0, 0, 0);
      this.cameraLookAtTarget.set(0, 0, 0);
    }
  }, {
    key: 'setupScene',
    value: function setupScene() {
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color('hsl(0, 0%, 3%)');
    }
  }, {
    key: 'setupLights',
    value: function setupLights() {}
  }, {
    key: 'setupRenderer',
    value: function setupRenderer() {
      this.renderer = new THREE.WebGLRenderer({
        //antialias: true,
        precision: 'highp'
      });
      this.renderer.autoClear = false;
      this.renderer.shadowMap.enabled = true;
      this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      this.game.dom.container.appendChild(this.renderer.domElement);
    }
  }, {
    key: 'setupCameras',
    value: function setupCameras() {
      this.fov = 100;
      this.camera = new THREE.PerspectiveCamera(this.fov, 0, 0.1, 1000);
      this.camera.position.set(-5, 5, 5);
      this.cameraCurrent = new THREE.Vector3();
      this.cameraTarget = new THREE.Vector3();
      this.cameraLookAtCurrent = new THREE.Vector3();
      this.cameraLookAtTarget = new THREE.Vector3();

      // this.orbit = new THREE.OrbitControls(this.camera, this.game.dom.container);
      // this.orbit.enableDamping = true;
      // this.orbit.dampingFactor = 0.2;
      // this.orbit.enableKeys = false;
    }
  }, {
    key: 'setupComposer',
    value: function setupComposer() {
      this.composer = new THREE.EffectComposer(this.renderer);

      this.renderPass = new THREE.RenderPass(this.scene, this.camera);
      this.renderPass.renderToScreen = false;
      //this.renderPass.clear = false;
      //this.renderPass.clearDepth = true;
      this.composer.addPass(this.renderPass);

      this.brightnessPass = new THREE.ShaderPass(THREE.BrightnessContrastShader);
      this.brightnessValue = 0;
      this.brightnessPass.uniforms['brightness'].value = 0;
      this.brightnessPass.uniforms['contrast'].value = 0;
      this.brightnessPass.renderToScreen = false;
      this.composer.addPass(this.brightnessPass);

      this.rgbPass = new THREE.ShaderPass(THREE.RGBShiftShader);
      this.rgbPass.uniforms['amount'].value = 0;
      this.rgbPass.uniforms['angle'].value = 0;
      this.rgbPass.renderToScreen = false;
      this.composer.addPass(this.rgbPass);

      this.bloomPass = new THREE.UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), // resolution
      0.75, // strength
      0.5, // radius
      0.75 //threshold
      );
      this.bloomPass.renderToScreen = false;
      this.composer.addPass(this.bloomPass);

      // noiseIntensity, scanlinesIntensity, scanlinesCount, grayscale
      this.filmPass = new THREE.FilmPass(0.15, 0.5, 2048, false);
      this.filmPass.renderToScreen = true;
      this.composer.addPass(this.filmPass);
    }
  }, {
    key: 'setupGrid',
    value: function setupGrid() {
      // this.gridHelper = new THREE.GridHelper(100, 100, 0xffffff, 0x666666);
      // this.gridHelper.material.transparent = true;
      // this.gridHelper.material.opacity = 0.2;
      // this.scene.add(this.gridHelper);
    }
  }, {
    key: 'update',
    value: function update() {
      //this.orbit.update();
      if (this.game.activeHero && this.game.stateManager.current === 'play') {
        this.cameraTarget.copy(this.game.activeHero.mesh.position);
        //this.cameraTarget.y = 3;
        this.cameraTarget.y = this.cameraLift;
        this.cameraTarget.z += 0;

        this.cameraLookAtTarget.copy(this.game.activeHero.mesh.position);

        this.cameraCurrent.lerp(this.cameraTarget, 0.15);
        this.cameraLookAtCurrent.lerp(this.cameraLookAtTarget, 0.15);

        this.camera.position.copy(this.cameraCurrent);
        this.camera.lookAt(this.cameraLookAtCurrent);
      }

      this.rgbPass.uniforms['amount'].value = 0.0008 + Math.sin(Date.now() * 0.003) * 0.0008;
      this.rgbPass.uniforms['angle'].value -= 0.1;
      //this.bloomPass.strength = 0.5 + Math.sin(Date.now() * 0.003) * 0.5;
      //this.bloomPass.radius = 1 + Math.sin(Date.now() * 0.003) * 1;
      //this.bloomPass.radius = 0.5 - Math.sin(Date.now() * 0.003) * 0.25;

      if (!this.game.isEnding) {
        if (this.brightnessValue > 0) {
          this.brightnessValue -= 0.001;
          if (this.brightnessValue < 0) {
            this.brightnessValue = 0;
          }
        }
      }
      this.brightnessPass.uniforms['brightness'].value = this.brightnessValue;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.game.stateManager.current != 'play') {
        return;
      }
      //this.renderer.render(this.scene, this.camera);
      this.composer.render(0.00001);
    }
  }, {
    key: 'onGameResize',
    value: function onGameResize(e) {
      this.camera.aspect = e.aspect;
      this.camera.updateProjectionMatrix();

      this.renderer.setPixelRatio(e.dpr);
      this.renderer.setSize(e.resolution.x, e.resolution.y);
      this.composer.setSize(e.resolution.x * e.dpr, e.resolution.y * e.dpr);

      this.filmPass.uniforms.sCount.value = e.resolution.y * 2;
    }
  }, {
    key: 'onGameAnimate',
    value: function onGameAnimate() {
      this.update();
      this.render();
    }
  }]);

  return World;
}();

module.exports = World;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
],[9]);


// WEBPACK FOOTER //
// game.js